<template src="./index.html">
</template>
<script>
	import minhead from '../../../../common/minHead/index.vue'
	import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue'
	import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue'
	import {
		getdata
	} from './data.js'
	import config from '../../../../../../configHttp.js'
	import uploadFile from '../../../../common/uploadFile/index.vue'
	import uploadFileplus from '../../../../common/uploadFileplus/index.vue'
	import {
		querycell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd,
		checkIsUploadFz
	} from "../../../../../api/Draftgeneration.js"
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave
	} from "../../../../../api/bbmb.js"
	import {
		reportquerytrack
	} from "../../../../../api/xggj.js"
	import {
		zcfg_fycx,
		zcfg_fetch
	} from "../../../../../api/zcfg.js";
	import addzc from "../../../../common/addzc/index.vue";
	import seezc from "../../../../common/seezc/index.vue"
	import AssetsAndLiabilitiesY_I from "./AssetsAndLiabilitiesY_I/index.vue"
	import {
		getdata as getdataI
	} from './AssetsAndLiabilitiesY_I/data.js'
	import AssetsAndLiabilitiesY_II from "./AssetsAndLiabilitiesY_II/index.vue"
	import {
		getdata as getdataII
	} from './AssetsAndLiabilitiesY_II/data.js'
	import AssetsAndLiabilitiesY_III from "./AssetsAndLiabilitiesY_III/index.vue"
	import {
		getdata as getdataIII
	} from './AssetsAndLiabilitiesY_III/data.js'
	import AssetsAndLiabilitiesY_VI from "./AssetsAndLiabilitiesY_VI/index.vue"
	import {
		getdata as getdataVI
	} from './AssetsAndLiabilitiesY_VI/data.js'
	export default {
		name: '',
		components: {
			minhead,
			SalesTaxReportTree,
			SalesTaxReportbox,
			uploadFile,
			uploadFileplus,
			addzc,
			seezc,
			AssetsAndLiabilitiesY_I,
			AssetsAndLiabilitiesY_II,
			AssetsAndLiabilitiesY_III,
			AssetsAndLiabilitiesY_VI,
		},
		props: {
			seeNow: {
				type: Boolean,
				default: false
			},
			type: {
				type: String,
				default: ""
			},
			params: {
				type: Object,
				default: {}
			},
			suosq: {
				type: String,
				default: ""
			},
			showbox: {
				type: Boolean,
				default: false
			},
			mintext: {
				type: String,
				default: "填写"
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},

		mounted() {
			if (this.toseeUpdate) {
				this.getShuibDetailList()
			} else {
				this.manuscriptqueryReportStep()
			}
		},
		data: function() {
			return {
				treestate: "",
				statedata: [],
				treedata: null,
				choosetitleindex: "",
				formlist: getdata().formlist,
				headobj: {},
				choosecellCode: "",
				smtext: "",
				Changed:0,
				zcdata: [],
				searchlistzc: getdata().searchlistzc,
				headDatazc: getdata().headDatazc,
				pagination: getdata().pagination,
				seezcformlist: getdata().seezcformlist,
				formdatazc: getdata().formdatazc, //form表单数据
				tableDataI: [],
				tableDataII: [],
				tableDataIII: [],
				tableDataVI: [],
				tableDataci: [],
				ZeroHea: ['cwbbyzx_0_x_1', 'cwbbyzx_0_x_2'],
				IHead: ['cwbbyzx_1_x_1', 'cwbbyzx_1_x_2'],
				IIHead: ['cwbbyzx_2_x_1', 'cwbbyzx_2_x_2'],
				IIIHead: ['cwbbyzx_3_x_1', 'cwbbyzx_3_x_2', 'cwbbyzx_3_x_3', 'cwbbyzx_3_x_4', 'cwbbyzx_3_x_5',
					'cwbbyzx_3_x_6', 'cwbbyzx_3_x_7', 'cwbbyzx_3_x_8', 'cwbbyzx_3_x_9', 'cwbbyzx_3_x_10',
					'cwbbyzx_3_x_11', 'cwbbyzx_3_x_12', 'cwbbyzx_3_x_13', 'cwbbyzx_3_x_14', 'cwbbyzx_3_x_15',
					'cwbbyzx_3_x_16', 'cwbbyzx_3_x_17', 'cwbbyzx_3_x_18', 'cwbbyzx_3_x_19', 'cwbbyzx_3_x_20',
					'cwbbyzx_3_x_21', 'cwbbyzx_3_x_22'
				],
				choosetable: '',
				chooseindex: '',
				choosecolum: '',
				errarr: [],
				errdiag: false,
			};
		},

		methods: {
			//政策点击预览
			zcsclick(id) {
				this.$refs.boxref.zcsclick(id)
			},
			//选中格子
			forhover(table, colum, index) {
				this.$refs.boxref.forhover(table, colum, index)
			},
			//获取选中格子
			getchoosecellCode(table, colum, index) {
				if (this.$emptyandnull(table)) {
					this.choosecellCode = ""
					return false
				}
				this.choosetable = table
				this.chooseindex = index
				this.choosecolum = colum
				this.choosecellCode = this[table][index][colum].cellCode
				if (this.toseeUpdate) {
					this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : ''
					this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : []
				} else {
					this.smtext = this[table][index][colum]['updateDesc'] || ''
				}
			},
			//更正说明
			forgengzheng(table, colum, index, smtext) {
				this[table][index][colum]['updateDesc'] = smtext
			},
			//更正政策和说明
			forxzsm(table, colum, index, smtext, zcdata) {
				this[table][index][colum]['map'] = {
					desc: "",
					zcs: []
				}
				this[table][index][colum]['map']['desc'] = smtext
				this[table][index][colum]['map']['zcs'] = zcdata
			},
			//点击全部范围
			refreshhover() {
                this.$nextTick(()=>{
                    this.$refs.boxref.refreshhover()
                })
			},
			getShuibDetailList() {
				getShuibDetailList({
					shuizId: this.params.shuizId,
					id: this.params.shuibId
				}).then(res => {
					if (res.data.code == 1) {
						this.treedata = res.data.data
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0])
						}
						this.querycell()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			manuscriptqueryReportStep() {
				manuscriptqueryReportStep({
					id: this.params.id,
					sbbm: this.params.sbbm
				}).then(res => {
					if (res.data.code == 1) {
						this.statedata = res.data.data.statusHistory
						this.treedata = res.data.data.detail
						// this.treedata[0].unshift()
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0])
						}
						this.querycell()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			getchoosetitleindex(item) {
				this.choosetitleindex = item.shuibNameCode
			},
			//表格隐藏显示和返回
			forback() {
			if(this.Changed>0){
					this.$showConfirm({
							message: "是否不保存当前修改?",
							title:"您还未保存",
					}).then((res) => {
							if (res == "confirm") {
									this.$emit('forback', true);
							}else{
									//取消
							}
					});
			}else{
				this.$emit('forback', true);
			}
		},
			changestate(e) {
				this.treestate = e
			},
			//传给后端值处理
			filternums(data, filterlist) {
				var newlist = []
				filterlist.forEach(ytem => {
					let newval = data.map(item => {
						if (item[ytem] != undefined && item[ytem] != 'undefined' && this.$notemptyandnull(
								item[ytem]) && item[ytem].cellVal != null) {
							return item[ytem]
						} else {
							return "x"
						}
					})
					newlist = [...newlist, ...newval].filter(gtem => gtem != 'x')
				})
				return newlist
			},
			//本栏开始替换
			//重置主表
			refreshtableDataZero() {
				this.tableDataI.forEach((item, index) => {
					if (index != 0) {
						this.ZeroHea.forEach(gtem => {
							if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
								.cellVal != '- -') {
								item[gtem].cellVal = ""
								item[gtem].cellType = "0"
							}
						})
					}
				})
				this.tableDataci.forEach((item, index) => {
					if (index != 0) {
						this.ZeroHea.forEach(gtem => {
							if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
								.cellVal != '- -') {
								item[gtem].cellVal = ""
								item[gtem].cellType = "0"
							}
						})
					}
				})
			},
			//重置附表一
			refreshtableDataI() {
				this.tableDataII.forEach((item, index) => {
					this.IHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
			},
			//重置附表二
			refreshtableDataII() {
				this.tableDataIII.forEach((item, index) => {
					this.IIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
			},
			//重置附表三
			refreshtableDataIII() {
				this.tableDataVI.forEach((item, index) => {
					this.IIIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
			},
			//重置附表四
			//清空相关
			commanddcrefresh(e) {
				this.Changed++
				if (e == "now") {
					if (this.choosetitleindex == 'cwbbyzx_0') {
						this.refreshtableDataZero()
					}
					if (this.choosetitleindex == 'cwbbyzx_1') {
						this.refreshtableDataI()
					}
					if (this.choosetitleindex == 'cwbbyzx_2') {
						this.refreshtableDataII()
					}
					if (this.choosetitleindex == 'cwbbyzx_3') {
						this.refreshtableDataIII()
					}
				}
				if (e == "all") { Object.keys(this.headobj).map(key => (this.headobj[key] = ""));
					this.refreshtableDataZero()
					this.refreshtableDataI()
					this.refreshtableDataII()
					this.refreshtableDataIII()
				}
			},
			//所有表格渲染
			querycell(index) {

				if (this.type == "update") {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm,
					}).then(res => {
						let dataarr = res.data.data
						this.gettable(dataarr)
					})
				}
				if (this.type == "tosee") {
					if (this.seeNow) {
						querycell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm,
						}).then(res => {
							let dataarr = res.data.data
							this.gettable(dataarr)
						})
						return false
					}
					if (this.toseeUpdate) {
						querytemplatecell({
							"shuibId": this.params.shuibId,
							"id": this.params.id
						}).then(res => {
							let dataarr = res.data.data
							this.gettable(dataarr)
						})
					} else {
						reportquerytrack({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm,
							trackId: this.params.trackId,
						}).then(res => {
							let dataarr = res.data.data
							this.gettable(dataarr)
						})
					}
				}

			},
			gettable(dataarr) {
				this.headobj = dataarr.head
				if (dataarr.cwbbyzx_0) {
					dataarr.cwbbyzx_0.unshift({
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(15, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(35, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(36, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(37, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(38, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(39, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(41, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(56, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
					dataarr.cwbbyzx_0.splice(69, 0, {
						cwbbyzx_0_x_1: {
							cellType: "0",
						},
						cwbbyzx_0_x_2: {
							cellType: "0",
						}
					})
				}
				var newtabledataZero = dataarr.cwbbyzx_0
				var realtableDataout = newtabledataZero.filter((item, index) => index < 41)
				var realtableDataZero = getdataI().tableData
				realtableDataZero.forEach((item, index) => {
					if (realtableDataout[index]) {
						this.ZeroHea.forEach(gtem => {
							item[gtem] = realtableDataout[index][gtem]
						})
					}
				})
				this.tableDataI = realtableDataZero
				var newtabledataV = newtabledataZero.filter((item, index) => index > 40)
				var realtableDataV = getdataI().tableDatas
				realtableDataV.forEach((item, index) => {
					if (newtabledataV[index]) {
						this.ZeroHea.forEach(gtem => {
							item[gtem] = newtabledataV[index][gtem]
						})
					}
				})
				this.tableDataci = realtableDataV
				//附表一
				var newtabledataI = dataarr.cwbbyzx_1
				var realtableDataI = getdataII().tableData
				realtableDataI.forEach((item, index) => {
					if (newtabledataI[index]) {
						this.IHead.forEach(gtem => {
							item[gtem] = newtabledataI[index][gtem]
						})
					}
				})
				this.tableDataII = realtableDataI
				//附表二
				var newtabledataII = dataarr.cwbbyzx_2
				var realtableDataII_I = getdataIII().tableData
				realtableDataII_I.forEach((item, index) => {
					if (newtabledataII[index]) {
						this.IIHead.forEach(gtem => {
							item[gtem] = newtabledataII[index][gtem]
						})
					}
				})

				this.tableDataIII = realtableDataII_I
				//附表三
				var newtabledataIII = dataarr.cwbbyzx_3
				var realtableDataIII = getdataVI().tableData
				realtableDataIII.forEach((item, index) => {
					if (newtabledataIII[index]) {
						this.IIIHead.forEach(gtem => {
							item[gtem] = newtabledataIII[index][gtem]
						})
					}
				})
				this.tableDataVI = realtableDataIII
			},
			checkerror(){
				let arr = []
				if (this.gettableval("cwbbyzx_0_34_1", 'tableDataI') != this.gettableval("cwbbyzx_0_72_1", 'tableDataci')) {
					arr.push("资产负债表第72栏次第1列 应满足条件:资产负债表第34栏次第1列=资产负债表第72栏次第1列")
				}
				if (this.gettableval("cwbbyzx_0_34_2", 'tableDataI') != this.gettableval("cwbbyzx_0_72_2", 'tableDataci')) {
					arr.push("资产负债表第72栏次第2列 应满足条件:资产负债表第34栏次第2列=资产负债表第72栏次第2列")
				}
				if (arr.length > 0) {
					this.errarr = arr
					this.errdiag = true
					return false
				} else {
					return true
				}
			},
			next(){
				
					let status = this.checkerror()
					const newarr = [...this.filternums(this.tableDataI, this.ZeroHea), ...this.filternums(this.tableDataci,
						this.ZeroHea), ...this.filternums(this.tableDataII,
						this.IHead), ...this.filternums(this.tableDataIII, this.IIHead), ...this.filternums(this
						.tableDataVI, this.IIIHead)]

					let params = {
						"cells": newarr,
						"companyNo": this.params.companyNo,
						"id": this.params.id,
						"sbbm": this.params.sbbm,
						"head": this.headobj,
						"checkFlag":status
					}
					writesave(params).then(res => {
						if (res.data.code == 1) {
							this.Changed = 0
							this.querycell()
							this.$message.success(res.data.msg)
						} else {
							this.$message.error(res.data.msg)
						}
					})
				
			},
			forsave() {
				let param = {
					"companyNo": this.params.companyNo,
					"id": this.params.id,
				}
				checkIsUploadFz(param).then(res=>{
					if(res.data.code==1){
						if(res.data.data==0){
								this.$showConfirm({
									message: "您还未填写附注是否继续保存?",
									title:"标题",
								}).then((res) => {
									if (res == "confirm") {
												this.next()
									}else{
										
									}
								});
						}else{
								this.next()
						}
					}else{
						this.$message.error(res.data.msg)
					}
				})
				
			},
			inputblur(e) {
				this.Changed++
				if ((parseFloat(e.cellVal).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this
						.choosecolum
					]['cellOldVal']).toFixed(2)) && this[this.choosetable][this.chooseindex][this.choosecolum][
						'cellCode'
					] == e.cellCode) {
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = "1"
				}

				if (e.cellCode == "cwbbyzx_0_1_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_1_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_2_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_2_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_3_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_3_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_4_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_4_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_5_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_5_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_6_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_6_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_7_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_7_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_8_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_8_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_9_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_9_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_10_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_10_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_11_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_11_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_12_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_12_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_13_1") {
					this.cwbbyzx_0_14_1()
				}
				if (e.cellCode == "cwbbyzx_0_13_2") {
					this.cwbbyzx_0_14_2()
				}
				if (e.cellCode == "cwbbyzx_0_14_1") {
					this.changetableval("cwbbyzx_0_34_1", 'tableDataI', this.gettableval("cwbbyzx_0_14_1", 'tableDataI') +
						this.gettableval("cwbbyzx_0_33_1", 'tableDataI'))
				}
				if (e.cellCode == "cwbbyzx_0_14_2") {
					this.changetableval("cwbbyzx_0_34_2", 'tableDataI', this.gettableval("cwbbyzx_0_14_2", 'tableDataI') +
						this.gettableval("cwbbyzx_0_33_2", 'tableDataI'))
				}
				if (e.cellCode == "cwbbyzx_0_15_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_15_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_16_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_16_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_17_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_17_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_18_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_18_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_19_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_19_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_20_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_20_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_21_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_21_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_22_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_22_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_23_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_23_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_24_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_24_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_25_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_25_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_26_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_26_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_27_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_27_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_28_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_28_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_29_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_29_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_30_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_30_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_31_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_31_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_32_1") {
					this.cwbbyzx_0_33_1()
				}
				if (e.cellCode == "cwbbyzx_0_32_2") {
					this.cwbbyzx_0_33_2()
				}
				if (e.cellCode == "cwbbyzx_0_33_1") {
					this.changetableval("cwbbyzx_0_34_1", 'tableDataI', this.gettableval("cwbbyzx_0_14_1", 'tableDataI') +
						this.gettableval("cwbbyzx_0_33_1", 'tableDataI'))
				}
				if (e.cellCode == "cwbbyzx_0_33_2") {
					this.changetableval("cwbbyzx_0_34_2", 'tableDataI', this.gettableval("cwbbyzx_0_14_2", 'tableDataI') +
						this.gettableval("cwbbyzx_0_33_2", 'tableDataI'))
				}
				if (e.cellCode == "cwbbyzx_0_35_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_35_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_36_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_36_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_37_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_37_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_38_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_38_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_39_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_39_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_40_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_40_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_41_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_41_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_42_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_42_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_43_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_43_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_44_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_44_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_45_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_45_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_46_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_46_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_47_1") {
					this.cwbbyzx_0_48_1()
				}
				if (e.cellCode == "cwbbyzx_0_47_2") {
					this.cwbbyzx_0_48_2()
				}
				if (e.cellCode == "cwbbyzx_0_48_1") {
					this.changetableval("cwbbyzx_0_60_1", 'tableDataci', this.gettableval("cwbbyzx_0_48_1",
						'tableDataci') +
						this.gettableval("cwbbyzx_0_59_1", 'tableDataci'))
				}
				if (e.cellCode == "cwbbyzx_0_48_2") {
					this.changetableval("cwbbyzx_0_60_2", 'tableDataci', this.gettableval("cwbbyzx_0_48_2",
						'tableDataci') +
						this.gettableval("cwbbyzx_0_59_2", 'tableDataci'))
				}
				if (e.cellCode == "cwbbyzx_0_49_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_49_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_50_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_50_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_51_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_51_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_52_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_52_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_53_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_53_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_54_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_54_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_55_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_55_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_56_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_56_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_57_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_57_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_58_1") {
					this.cwbbyzx_0_59_1()
				}
				if (e.cellCode == "cwbbyzx_0_58_2") {
					this.cwbbyzx_0_59_2()
				}
				if (e.cellCode == "cwbbyzx_0_59_1") {
					this.changetableval("cwbbyzx_0_60_1", 'tableDataci', this.gettableval("cwbbyzx_0_48_1",'tableDataci') +
						this.gettableval("cwbbyzx_0_59_1", 'tableDataci'))
				}
				if (e.cellCode == "cwbbyzx_0_59_2") {
					this.changetableval("cwbbyzx_0_60_2", 'tableDataci', this.gettableval("cwbbyzx_0_48_2",'tableDataci') +
						this.gettableval("cwbbyzx_0_59_2", 'tableDataci'))
				}
				if (e.cellCode == "cwbbyzx_0_60_1") {
					this.changetableval("cwbbyzx_0_72_1", 'tableDataci', this.gettableval("cwbbyzx_0_60_1",'tableDataci') +
						this.gettableval("cwbbyzx_0_71_1", 'tableDataci'))
				}
				if (e.cellCode == "cwbbyzx_0_60_2") {
					this.changetableval("cwbbyzx_0_72_2", 'tableDataci', this.gettableval("cwbbyzx_0_60_2",'tableDataci') +
						this.gettableval("cwbbyzx_0_71_2", 'tableDataci'))
				}
				if (e.cellCode == "cwbbyzx_0_61_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_61_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_62_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_62_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_63_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_63_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_64_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_64_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_65_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_65_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_66_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_66_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_67_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_67_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_68_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_68_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_69_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_69_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_70_1") {
					this.cwbbyzx_0_71_1()
				}
				if (e.cellCode == "cwbbyzx_0_70_2") {
					this.cwbbyzx_0_71_2()
				}
				if (e.cellCode == "cwbbyzx_0_71_1") {
					this.changetableval("cwbbyzx_0_72_1", 'tableDataci', this.gettableval("cwbbyzx_0_60_1",'tableDataci') +
						this.gettableval("cwbbyzx_0_71_1", 'tableDataci'))
				}
				if (e.cellCode == "cwbbyzx_0_71_2") {
					this.changetableval("cwbbyzx_0_72_2", 'tableDataci', this.gettableval("cwbbyzx_0_60_2",'tableDataci') +
						this.gettableval("cwbbyzx_0_71_2", 'tableDataci'))
				}

				// 第二张表
				if (e.cellCode == "cwbbyzx_1_1_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_1_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_2_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_2_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_3_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_3_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_4_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_4_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_5_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_5_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_6_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_6_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_7_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_7_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_10_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_10_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_11_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_11_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_14_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_14_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_15_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_15_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_16_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_16_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_17_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_17_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_18_1") {
					this.cwbbyzx_1_19_1()
				}
				if (e.cellCode == "cwbbyzx_1_18_2") {
					this.cwbbyzx_1_19_2()
				}
				if (e.cellCode == "cwbbyzx_1_19_1") {
					this.changetableval("cwbbyzx_1_22_1", 'tableDataII', this.gettableval("cwbbyzx_1_19_1", 'tableDataII') +
					this.gettableval("cwbbyzx_1_20_1", 'tableDataII')- this.gettableval("cwbbyzx_1_21_1",
						'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_19_2") {
					this.changetableval("cwbbyzx_1_22_2", 'tableDataII', this.gettableval("cwbbyzx_1_19_2", 'tableDataII') +
					this.gettableval("cwbbyzx_1_20_2", 'tableDataII')- this.gettableval("cwbbyzx_1_21_2",
						'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_20_1") {
					this.changetableval("cwbbyzx_1_22_1", 'tableDataII', this.gettableval("cwbbyzx_1_19_1", 'tableDataII') +
					this.gettableval("cwbbyzx_1_20_1", 'tableDataII')- this.gettableval("cwbbyzx_1_21_1",
						'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_20_2") {
					this.changetableval("cwbbyzx_1_22_2", 'tableDataII', this.gettableval("cwbbyzx_1_19_2", 'tableDataII') +
					this.gettableval("cwbbyzx_1_20_2", 'tableDataII')- this.gettableval("cwbbyzx_1_21_2",
						'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_21_1") {
					this.changetableval("cwbbyzx_1_22_1", 'tableDataII', this.gettableval("cwbbyzx_1_19_1", 'tableDataII') +
					this.gettableval("cwbbyzx_1_20_1", 'tableDataII')- this.gettableval("cwbbyzx_1_21_1",
						'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_21_2") {
					this.changetableval("cwbbyzx_1_22_2", 'tableDataII', this.gettableval("cwbbyzx_1_19_2", 'tableDataII') +
					this.gettableval("cwbbyzx_1_20_2", 'tableDataII')- this.gettableval("cwbbyzx_1_21_2",
						'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_22_1") {
					this.changetableval("cwbbyzx_1_24_1", 'tableDataII', this.gettableval("cwbbyzx_1_22_1", 'tableDataII') -
					this.gettableval("cwbbyzx_1_23_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_22_2") {
					this.changetableval("cwbbyzx_1_24_2", 'tableDataII', this.gettableval("cwbbyzx_1_22_2", 'tableDataII') -
					this.gettableval("cwbbyzx_1_23_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_23_1") {
					this.changetableval("cwbbyzx_1_24_1", 'tableDataII', this.gettableval("cwbbyzx_1_22_1", 'tableDataII') -
					this.gettableval("cwbbyzx_1_23_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_23_2") {
					this.changetableval("cwbbyzx_1_24_2", 'tableDataII', this.gettableval("cwbbyzx_1_22_2", 'tableDataII') -
					this.gettableval("cwbbyzx_1_23_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_24_1") {
					this.changetableval("cwbbyzx_1_40_1", 'tableDataII', this.gettableval("cwbbyzx_1_27_1", 'tableDataII') +
					this.gettableval("cwbbyzx_1_24_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_24_2") {
					this.changetableval("cwbbyzx_1_40_2", 'tableDataII', this.gettableval("cwbbyzx_1_27_2", 'tableDataII') +
					this.gettableval("cwbbyzx_1_24_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_27_1") {
					this.changetableval("cwbbyzx_1_40_1", 'tableDataII', this.gettableval("cwbbyzx_1_27_1", 'tableDataII') +
					this.gettableval("cwbbyzx_1_24_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_27_2") {
					this.changetableval("cwbbyzx_1_40_2", 'tableDataII', this.gettableval("cwbbyzx_1_27_2", 'tableDataII') +
					this.gettableval("cwbbyzx_1_24_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_28_1") {
					this.changetableval("cwbbyzx_1_27_1", 'tableDataII', this.gettableval("cwbbyzx_1_28_1", 'tableDataII') +
					this.gettableval("cwbbyzx_1_33_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_28_2") {
					this.changetableval("cwbbyzx_1_27_2", 'tableDataII', this.gettableval("cwbbyzx_1_28_2", 'tableDataII') +
					this.gettableval("cwbbyzx_1_33_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_29_1") {
					this.changetableval("cwbbyzx_1_28_1", 'tableDataII', this.gettableval("cwbbyzx_1_30_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_1",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_29_2") {
					this.changetableval("cwbbyzx_1_28_2", 'tableDataII', this.gettableval("cwbbyzx_1_30_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_2",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_30_1") {
					this.changetableval("cwbbyzx_1_28_1", 'tableDataII', this.gettableval("cwbbyzx_1_30_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_1",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_30_2") {
					this.changetableval("cwbbyzx_1_28_2", 'tableDataII', this.gettableval("cwbbyzx_1_30_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_2",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_31_1") {
					this.changetableval("cwbbyzx_1_28_1", 'tableDataII', this.gettableval("cwbbyzx_1_30_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_1",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_31_2") {
					this.changetableval("cwbbyzx_1_28_2", 'tableDataII', this.gettableval("cwbbyzx_1_30_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_2",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_32_1") {
					this.changetableval("cwbbyzx_1_28_1", 'tableDataII', this.gettableval("cwbbyzx_1_30_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_1",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_32_2") {
					this.changetableval("cwbbyzx_1_28_2", 'tableDataII', this.gettableval("cwbbyzx_1_30_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_31_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_32_2",'tableDataII') +
						this.gettableval("cwbbyzx_1_29_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_33_1") {
					this.changetableval("cwbbyzx_1_27_1", 'tableDataII', this.gettableval("cwbbyzx_1_28_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_33_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_33_2") {
					this.changetableval("cwbbyzx_1_27_2", 'tableDataII', this.gettableval("cwbbyzx_1_28_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_33_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_34_1") {
					this.changetableval("cwbbyzx_1_33_1", 'tableDataII', this.gettableval("cwbbyzx_1_34_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_34_2") {
					this.changetableval("cwbbyzx_1_33_2", 'tableDataII', this.gettableval("cwbbyzx_1_34_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_35_1") {
					this.changetableval("cwbbyzx_1_33_1", 'tableDataII', this.gettableval("cwbbyzx_1_34_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_35_2") {
					this.changetableval("cwbbyzx_1_33_2", 'tableDataII', this.gettableval("cwbbyzx_1_34_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_36_1") {
					this.changetableval("cwbbyzx_1_33_1", 'tableDataII', this.gettableval("cwbbyzx_1_34_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_36_2") {
					this.changetableval("cwbbyzx_1_33_2", 'tableDataII', this.gettableval("cwbbyzx_1_34_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_37_1") {
					this.changetableval("cwbbyzx_1_33_1", 'tableDataII', this.gettableval("cwbbyzx_1_34_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_37_2") {
					this.changetableval("cwbbyzx_1_33_2", 'tableDataII', this.gettableval("cwbbyzx_1_34_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_38_1") {
					this.changetableval("cwbbyzx_1_33_1", 'tableDataII', this.gettableval("cwbbyzx_1_34_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_38_2") {
					this.changetableval("cwbbyzx_1_33_2", 'tableDataII', this.gettableval("cwbbyzx_1_34_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_2", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_39_1") {
					this.changetableval("cwbbyzx_1_33_1", 'tableDataII', this.gettableval("cwbbyzx_1_34_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_1", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_1", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_1", 'tableDataII'))
				}
				if (e.cellCode == "cwbbyzx_1_39_2") {
					this.changetableval("cwbbyzx_1_33_2", 'tableDataII', this.gettableval("cwbbyzx_1_34_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_35_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_36_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_37_2", 'tableDataII')+ this.gettableval("cwbbyzx_1_38_2", 'tableDataII') +
						this.gettableval("cwbbyzx_1_39_2", 'tableDataII'))
				}

				// 第三张表
				if (e.cellCode == "cwbbyzx_2_2_1") {
					this.changetableval("cwbbyzx_2_5_1", 'tableDataIII', this.gettableval("cwbbyzx_2_2_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_3_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_4_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_2_2") {
					this.changetableval("cwbbyzx_2_5_2", 'tableDataIII', this.gettableval("cwbbyzx_2_2_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_3_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_4_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_3_1") {
					this.changetableval("cwbbyzx_2_5_1", 'tableDataIII', this.gettableval("cwbbyzx_2_2_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_3_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_4_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_3_2") {
					this.changetableval("cwbbyzx_2_5_2", 'tableDataIII', this.gettableval("cwbbyzx_2_2_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_3_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_4_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_4_1") {
					this.changetableval("cwbbyzx_2_5_1", 'tableDataIII', this.gettableval("cwbbyzx_2_2_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_3_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_4_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_4_2") {
					this.changetableval("cwbbyzx_2_5_2", 'tableDataIII', this.gettableval("cwbbyzx_2_2_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_3_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_4_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_5_1") {
					this.changetableval("cwbbyzx_2_11_1", 'tableDataIII', this.gettableval("cwbbyzx_2_5_1", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_10_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_5_2") {
					this.changetableval("cwbbyzx_2_11_2", 'tableDataIII', this.gettableval("cwbbyzx_2_5_2", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_10_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_6_1") {
					this.changetableval("cwbbyzx_2_10_1", 'tableDataIII', this.gettableval("cwbbyzx_2_6_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_6_2") {
					this.changetableval("cwbbyzx_2_10_2", 'tableDataIII', this.gettableval("cwbbyzx_2_6_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_2", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_7_1") {
					this.changetableval("cwbbyzx_2_10_1", 'tableDataIII', this.gettableval("cwbbyzx_2_6_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_7_2") {
					this.changetableval("cwbbyzx_2_10_2", 'tableDataIII', this.gettableval("cwbbyzx_2_6_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_2", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_8_1") {
					this.changetableval("cwbbyzx_2_10_1", 'tableDataIII', this.gettableval("cwbbyzx_2_6_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_8_2") {
					this.changetableval("cwbbyzx_2_10_2", 'tableDataIII', this.gettableval("cwbbyzx_2_6_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_2", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_9_1") {
					this.changetableval("cwbbyzx_2_10_1", 'tableDataIII', this.gettableval("cwbbyzx_2_6_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_9_2") {
					this.changetableval("cwbbyzx_2_10_2", 'tableDataIII', this.gettableval("cwbbyzx_2_6_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_7_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_8_2", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_9_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_10_1") {
					this.changetableval("cwbbyzx_2_11_1", 'tableDataIII', this.gettableval("cwbbyzx_2_5_1", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_10_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_10_2") {
					this.changetableval("cwbbyzx_2_11_2", 'tableDataIII', this.gettableval("cwbbyzx_2_5_2", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_10_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_11_1") {
					this.changetableval("cwbbyzx_2_36_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_11_2") {
					this.changetableval("cwbbyzx_2_36_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_13_1") {
					this.changetableval("cwbbyzx_2_18_1", 'tableDataIII', this.gettableval("cwbbyzx_2_13_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_13_2") {
					this.changetableval("cwbbyzx_2_18_2", 'tableDataIII', this.gettableval("cwbbyzx_2_13_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_14_1") {
					this.changetableval("cwbbyzx_2_18_1", 'tableDataIII', this.gettableval("cwbbyzx_2_13_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_14_2") {
					this.changetableval("cwbbyzx_2_18_2", 'tableDataIII', this.gettableval("cwbbyzx_2_13_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_15_1") {
					this.changetableval("cwbbyzx_2_18_1", 'tableDataIII', this.gettableval("cwbbyzx_2_13_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_15_2") {
					this.changetableval("cwbbyzx_2_18_2", 'tableDataIII', this.gettableval("cwbbyzx_2_13_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_16_1") {
					this.changetableval("cwbbyzx_2_18_1", 'tableDataIII', this.gettableval("cwbbyzx_2_13_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_16_2") {
					this.changetableval("cwbbyzx_2_18_2", 'tableDataIII', this.gettableval("cwbbyzx_2_13_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_17_1") {
					this.changetableval("cwbbyzx_2_18_1", 'tableDataIII', this.gettableval("cwbbyzx_2_13_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_17_2") {
					this.changetableval("cwbbyzx_2_18_2", 'tableDataIII', this.gettableval("cwbbyzx_2_13_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_14_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_15_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_16_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_17_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_18_1") {
					this.changetableval("cwbbyzx_2_24_1", 'tableDataIII', this.gettableval("cwbbyzx_2_18_1", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_23_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_18_2") {
					this.changetableval("cwbbyzx_2_24_2", 'tableDataIII', this.gettableval("cwbbyzx_2_18_2", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_23_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_19_1") {
					this.changetableval("cwbbyzx_2_23_1", 'tableDataIII', this.gettableval("cwbbyzx_2_19_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_20_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_22_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_19_2") {
				this.changetableval("cwbbyzx_2_23_2", 'tableDataIII', this.gettableval("cwbbyzx_2_19_2", 'tableDataIII') +
					this.gettableval("cwbbyzx_2_20_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_2", 'tableDataIII')+
					this.gettableval("cwbbyzx_2_22_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_20_1") {
					this.changetableval("cwbbyzx_2_23_1", 'tableDataIII', this.gettableval("cwbbyzx_2_19_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_20_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_22_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_20_2") {
				this.changetableval("cwbbyzx_2_23_2", 'tableDataIII', this.gettableval("cwbbyzx_2_19_2", 'tableDataIII') +
					this.gettableval("cwbbyzx_2_20_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_2", 'tableDataIII')+
					this.gettableval("cwbbyzx_2_22_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_21_1") {
					this.changetableval("cwbbyzx_2_23_1", 'tableDataIII', this.gettableval("cwbbyzx_2_19_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_20_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_22_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_21_2") {
				this.changetableval("cwbbyzx_2_23_2", 'tableDataIII', this.gettableval("cwbbyzx_2_19_2", 'tableDataIII') +
					this.gettableval("cwbbyzx_2_20_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_2", 'tableDataIII')+
					this.gettableval("cwbbyzx_2_22_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_22_1") {
					this.changetableval("cwbbyzx_2_23_1", 'tableDataIII', this.gettableval("cwbbyzx_2_19_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_20_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_1", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_22_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_22_2") {
					this.changetableval("cwbbyzx_2_23_2", 'tableDataIII', this.gettableval("cwbbyzx_2_19_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_20_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_21_2", 'tableDataIII')+
						this.gettableval("cwbbyzx_2_22_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_23_1") {
					this.changetableval("cwbbyzx_2_24_1", 'tableDataIII', this.gettableval("cwbbyzx_2_18_1", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_23_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_23_2") {
					this.changetableval("cwbbyzx_2_24_2", 'tableDataIII', this.gettableval("cwbbyzx_2_18_2", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_23_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_24_1") {
					this.changetableval("cwbbyzx_2_36_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_24_2") {
					this.changetableval("cwbbyzx_2_36_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_26_1") {
					this.changetableval("cwbbyzx_2_29_1", 'tableDataIII', this.gettableval("cwbbyzx_2_26_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_27_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_28_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_26_2") {
					this.changetableval("cwbbyzx_2_29_2", 'tableDataIII', this.gettableval("cwbbyzx_2_26_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_27_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_28_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_27_1") {
					this.changetableval("cwbbyzx_2_29_1", 'tableDataIII', this.gettableval("cwbbyzx_2_26_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_27_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_28_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_27_2") {
					this.changetableval("cwbbyzx_2_29_2", 'tableDataIII', this.gettableval("cwbbyzx_2_26_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_27_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_28_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_28_1") {
					this.changetableval("cwbbyzx_2_29_1", 'tableDataIII', this.gettableval("cwbbyzx_2_26_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_27_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_28_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_28_2") {
					this.changetableval("cwbbyzx_2_29_2", 'tableDataIII', this.gettableval("cwbbyzx_2_26_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_27_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_28_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_29_1") {
					this.changetableval("cwbbyzx_2_34_1", 'tableDataIII', this.gettableval("cwbbyzx_2_29_1", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_33_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_29_2") {
					this.changetableval("cwbbyzx_2_34_2", 'tableDataIII', this.gettableval("cwbbyzx_2_29_2", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_33_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_30_1") {
					this.changetableval("cwbbyzx_2_33_1", 'tableDataIII', this.gettableval("cwbbyzx_2_30_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_31_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_32_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_30_2") {
					this.changetableval("cwbbyzx_2_33_2", 'tableDataIII', this.gettableval("cwbbyzx_2_30_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_31_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_32_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_31_1") {
					this.changetableval("cwbbyzx_2_33_1", 'tableDataIII', this.gettableval("cwbbyzx_2_30_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_31_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_32_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_31_2") {
					this.changetableval("cwbbyzx_2_33_2", 'tableDataIII', this.gettableval("cwbbyzx_2_30_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_31_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_32_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_32_1") {
					this.changetableval("cwbbyzx_2_33_1", 'tableDataIII', this.gettableval("cwbbyzx_2_30_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_31_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_32_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_32_2") {
					this.changetableval("cwbbyzx_2_33_2", 'tableDataIII', this.gettableval("cwbbyzx_2_30_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_31_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_32_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_33_1") {
					this.changetableval("cwbbyzx_2_34_1", 'tableDataIII', this.gettableval("cwbbyzx_2_29_1", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_33_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_33_2") {
					this.changetableval("cwbbyzx_2_34_2", 'tableDataIII', this.gettableval("cwbbyzx_2_29_2", 'tableDataIII') -
						this.gettableval("cwbbyzx_2_33_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_34_1") {
					this.changetableval("cwbbyzx_2_36_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_34_2") {
					this.changetableval("cwbbyzx_2_36_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_35_1") {
					this.changetableval("cwbbyzx_2_36_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_35_2") {
					this.changetableval("cwbbyzx_2_36_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII'))
					this.changetableval("cwbbyzx_2_38_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_2", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_37_1") {
					this.changetableval("cwbbyzx_2_38_1", 'tableDataIII', this.gettableval("cwbbyzx_2_11_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_1", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_1", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_1", 'tableDataIII'))
				}
				if (e.cellCode == "cwbbyzx_2_37_2") {
					this.changetableval("cwbbyzx_2_38_2", 'tableDataIII', this.gettableval("cwbbyzx_2_11_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_24_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_34_2", 'tableDataIII') +
						this.gettableval("cwbbyzx_2_35_2", 'tableDataIII')+ this.gettableval("cwbbyzx_2_37_2", 'tableDataIII'))
				}

				// 第四张表
				if (e.cellCode == "cwbbyzx_3_1_1") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_1", 'tableDataVI', this.gettableval("cwbbyzx_3_1_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_1", 'tableDataVI'))

				}
				if (e.cellCode == "cwbbyzx_3_1_2") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_2", 'tableDataVI', this.gettableval("cwbbyzx_3_1_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_3") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_3", 'tableDataVI', this.gettableval("cwbbyzx_3_1_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_4") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_4", 'tableDataVI', this.gettableval("cwbbyzx_3_1_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_5") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_5", 'tableDataVI', this.gettableval("cwbbyzx_3_1_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_6") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_6", 'tableDataVI', this.gettableval("cwbbyzx_3_1_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_7") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_7", 'tableDataVI', this.gettableval("cwbbyzx_3_1_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_8") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_8", 'tableDataVI', this.gettableval("cwbbyzx_3_1_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_9") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_9", 'tableDataVI', this.gettableval("cwbbyzx_3_1_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_10") {
					this.cwbbyzx_3_1_11()
					this.changetableval("cwbbyzx_3_5_10", 'tableDataVI', this.gettableval("cwbbyzx_3_1_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_12") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_12", 'tableDataVI', this.gettableval("cwbbyzx_3_1_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_13") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_13", 'tableDataVI', this.gettableval("cwbbyzx_3_1_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_14") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_14", 'tableDataVI', this.gettableval("cwbbyzx_3_1_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_15") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_15", 'tableDataVI', this.gettableval("cwbbyzx_3_1_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_16") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_16", 'tableDataVI', this.gettableval("cwbbyzx_3_1_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_17") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_17", 'tableDataVI', this.gettableval("cwbbyzx_3_1_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_18") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_18", 'tableDataVI', this.gettableval("cwbbyzx_3_1_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_19") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_19", 'tableDataVI', this.gettableval("cwbbyzx_3_1_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_20") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_20", 'tableDataVI', this.gettableval("cwbbyzx_3_1_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_1_21") {
					this.cwbbyzx_3_1_22()
					this.changetableval("cwbbyzx_3_5_21", 'tableDataVI', this.gettableval("cwbbyzx_3_1_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_21", 'tableDataVI'))
				}
				if(e.cellCode == "cwbbyzx_3_2_1"){
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_1", 'tableDataVI', this.gettableval("cwbbyzx_3_1_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_2") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_2", 'tableDataVI', this.gettableval("cwbbyzx_3_1_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_3") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_3", 'tableDataVI', this.gettableval("cwbbyzx_3_1_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_4") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_4", 'tableDataVI', this.gettableval("cwbbyzx_3_1_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_5") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_5", 'tableDataVI', this.gettableval("cwbbyzx_3_1_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_6") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_6", 'tableDataVI', this.gettableval("cwbbyzx_3_1_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_7") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_7", 'tableDataVI', this.gettableval("cwbbyzx_3_1_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_8") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_8", 'tableDataVI', this.gettableval("cwbbyzx_3_1_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_9") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_9", 'tableDataVI', this.gettableval("cwbbyzx_3_1_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_10") {
					this.cwbbyzx_3_2_11()
					this.changetableval("cwbbyzx_3_5_10", 'tableDataVI', this.gettableval("cwbbyzx_3_1_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_12") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_12", 'tableDataVI', this.gettableval("cwbbyzx_3_1_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_13") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_13", 'tableDataVI', this.gettableval("cwbbyzx_3_1_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_14") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_14", 'tableDataVI', this.gettableval("cwbbyzx_3_1_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_15") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_15", 'tableDataVI', this.gettableval("cwbbyzx_3_1_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_16") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_16", 'tableDataVI', this.gettableval("cwbbyzx_3_1_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_17") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_17", 'tableDataVI', this.gettableval("cwbbyzx_3_1_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_18") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_18", 'tableDataVI', this.gettableval("cwbbyzx_3_1_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_19") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_19", 'tableDataVI', this.gettableval("cwbbyzx_3_1_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_20") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_20", 'tableDataVI', this.gettableval("cwbbyzx_3_1_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_2_21") {
					this.cwbbyzx_3_2_22()
					this.changetableval("cwbbyzx_3_5_21", 'tableDataVI', this.gettableval("cwbbyzx_3_1_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_1") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_1", 'tableDataVI', this.gettableval("cwbbyzx_3_1_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_2") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_2", 'tableDataVI', this.gettableval("cwbbyzx_3_1_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_3") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_3", 'tableDataVI', this.gettableval("cwbbyzx_3_1_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_4") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_4", 'tableDataVI', this.gettableval("cwbbyzx_3_1_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_5") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_5", 'tableDataVI', this.gettableval("cwbbyzx_3_1_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_6") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_6", 'tableDataVI', this.gettableval("cwbbyzx_3_1_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_7") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_7", 'tableDataVI', this.gettableval("cwbbyzx_3_1_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_8") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_8", 'tableDataVI', this.gettableval("cwbbyzx_3_1_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_9") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_9", 'tableDataVI', this.gettableval("cwbbyzx_3_1_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_10") {
					this.cwbbyzx_3_3_11()
					this.changetableval("cwbbyzx_3_5_10", 'tableDataVI', this.gettableval("cwbbyzx_3_1_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_12") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_12", 'tableDataVI', this.gettableval("cwbbyzx_3_1_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_13") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_13", 'tableDataVI', this.gettableval("cwbbyzx_3_1_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_14") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_14", 'tableDataVI', this.gettableval("cwbbyzx_3_1_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_15") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_15", 'tableDataVI', this.gettableval("cwbbyzx_3_1_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_16") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_16", 'tableDataVI', this.gettableval("cwbbyzx_3_1_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_17") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_17", 'tableDataVI', this.gettableval("cwbbyzx_3_1_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_18") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_18", 'tableDataVI', this.gettableval("cwbbyzx_3_1_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_19") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_19", 'tableDataVI', this.gettableval("cwbbyzx_3_1_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_20") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_20", 'tableDataVI', this.gettableval("cwbbyzx_3_1_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_3_21") {
					this.cwbbyzx_3_3_22()
					this.changetableval("cwbbyzx_3_5_21", 'tableDataVI', this.gettableval("cwbbyzx_3_1_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_1") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_1", 'tableDataVI', this.gettableval("cwbbyzx_3_1_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_2") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_2", 'tableDataVI', this.gettableval("cwbbyzx_3_1_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_3") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_3", 'tableDataVI', this.gettableval("cwbbyzx_3_1_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_4") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_4", 'tableDataVI', this.gettableval("cwbbyzx_3_1_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_5") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_5", 'tableDataVI', this.gettableval("cwbbyzx_3_1_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_6") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_6", 'tableDataVI', this.gettableval("cwbbyzx_3_1_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_7") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_7", 'tableDataVI', this.gettableval("cwbbyzx_3_1_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_8") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_8", 'tableDataVI', this.gettableval("cwbbyzx_3_1_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_9") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_9", 'tableDataVI', this.gettableval("cwbbyzx_3_1_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_10") {
					this.cwbbyzx_3_4_11()
					this.changetableval("cwbbyzx_3_5_10", 'tableDataVI', this.gettableval("cwbbyzx_3_1_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_12") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_12", 'tableDataVI', this.gettableval("cwbbyzx_3_1_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_13") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_13", 'tableDataVI', this.gettableval("cwbbyzx_3_1_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_14") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_14", 'tableDataVI', this.gettableval("cwbbyzx_3_1_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_15") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_15", 'tableDataVI', this.gettableval("cwbbyzx_3_1_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_16") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_16", 'tableDataVI', this.gettableval("cwbbyzx_3_1_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_17") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_17", 'tableDataVI', this.gettableval("cwbbyzx_3_1_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_18") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_18", 'tableDataVI', this.gettableval("cwbbyzx_3_1_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_19") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_19", 'tableDataVI', this.gettableval("cwbbyzx_3_1_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_20") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_20", 'tableDataVI', this.gettableval("cwbbyzx_3_1_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_4_21") {
					this.cwbbyzx_3_4_22()
					this.changetableval("cwbbyzx_3_5_21", 'tableDataVI', this.gettableval("cwbbyzx_3_1_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_2_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_4_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_1") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_1", 'tableDataVI', this.gettableval("cwbbyzx_3_5_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_2") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_2", 'tableDataVI', this.gettableval("cwbbyzx_3_5_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_3") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_3", 'tableDataVI', this.gettableval("cwbbyzx_3_5_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_4") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_4", 'tableDataVI', this.gettableval("cwbbyzx_3_5_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_5") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_5", 'tableDataVI', this.gettableval("cwbbyzx_3_5_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_6") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_6", 'tableDataVI', this.gettableval("cwbbyzx_3_5_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_7") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_7", 'tableDataVI', this.gettableval("cwbbyzx_3_5_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_8") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_8", 'tableDataVI', this.gettableval("cwbbyzx_3_5_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_9") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_9", 'tableDataVI', this.gettableval("cwbbyzx_3_5_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_10") {
					this.cwbbyzx_3_5_11()
					this.changetableval("cwbbyzx_3_24_10", 'tableDataVI', this.gettableval("cwbbyzx_3_5_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_12") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_12", 'tableDataVI', this.gettableval("cwbbyzx_3_5_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_13") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_13", 'tableDataVI', this.gettableval("cwbbyzx_3_5_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_14") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_14", 'tableDataVI', this.gettableval("cwbbyzx_3_5_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_15") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_15", 'tableDataVI', this.gettableval("cwbbyzx_3_5_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_16") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_16", 'tableDataVI', this.gettableval("cwbbyzx_3_5_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_17") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_17", 'tableDataVI', this.gettableval("cwbbyzx_3_5_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_18") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_18", 'tableDataVI', this.gettableval("cwbbyzx_3_5_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_19") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_19", 'tableDataVI', this.gettableval("cwbbyzx_3_5_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_20") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_20", 'tableDataVI', this.gettableval("cwbbyzx_3_5_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_5_21") {
					this.cwbbyzx_3_5_22()
					this.changetableval("cwbbyzx_3_24_21", 'tableDataVI', this.gettableval("cwbbyzx_3_5_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_1") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_1", 'tableDataVI', this.gettableval("cwbbyzx_3_5_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_2") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_2", 'tableDataVI', this.gettableval("cwbbyzx_3_5_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_3") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_3", 'tableDataVI', this.gettableval("cwbbyzx_3_5_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_4") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_4", 'tableDataVI', this.gettableval("cwbbyzx_3_5_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_5") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_5", 'tableDataVI', this.gettableval("cwbbyzx_3_5_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_6") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_6", 'tableDataVI', this.gettableval("cwbbyzx_3_5_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_7") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_7", 'tableDataVI', this.gettableval("cwbbyzx_3_5_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_8") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_8", 'tableDataVI', this.gettableval("cwbbyzx_3_5_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_9") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_9", 'tableDataVI', this.gettableval("cwbbyzx_3_5_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_10") {
					this.cwbbyzx_3_6_11()
					this.changetableval("cwbbyzx_3_24_10", 'tableDataVI', this.gettableval("cwbbyzx_3_5_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_12") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_12", 'tableDataVI', this.gettableval("cwbbyzx_3_5_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_13") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_13", 'tableDataVI', this.gettableval("cwbbyzx_3_5_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_14") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_14", 'tableDataVI', this.gettableval("cwbbyzx_3_5_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_15") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_15", 'tableDataVI', this.gettableval("cwbbyzx_3_5_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_16") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_16", 'tableDataVI', this.gettableval("cwbbyzx_3_5_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_17") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_17", 'tableDataVI', this.gettableval("cwbbyzx_3_5_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_18") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_18", 'tableDataVI', this.gettableval("cwbbyzx_3_5_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_19") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_19", 'tableDataVI', this.gettableval("cwbbyzx_3_5_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_20") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_20", 'tableDataVI', this.gettableval("cwbbyzx_3_5_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_6_21") {
					this.cwbbyzx_3_6_22()
					this.changetableval("cwbbyzx_3_24_21", 'tableDataVI', this.gettableval("cwbbyzx_3_5_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_6_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_1") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_1", 'tableDataVI', this.gettableval("cwbbyzx_3_7_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_2") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_2", 'tableDataVI', this.gettableval("cwbbyzx_3_7_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_3") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_3", 'tableDataVI', this.gettableval("cwbbyzx_3_7_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_4") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_4", 'tableDataVI', this.gettableval("cwbbyzx_3_7_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_5") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_5", 'tableDataVI', this.gettableval("cwbbyzx_3_7_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_6") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_6", 'tableDataVI', this.gettableval("cwbbyzx_3_7_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_7") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_7", 'tableDataVI', this.gettableval("cwbbyzx_3_7_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_8") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_8", 'tableDataVI', this.gettableval("cwbbyzx_3_7_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_9") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_9", 'tableDataVI', this.gettableval("cwbbyzx_3_7_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_10") {
					this.cwbbyzx_3_7_11()
					this.changetableval("cwbbyzx_3_6_10", 'tableDataVI', this.gettableval("cwbbyzx_3_7_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_12") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_12", 'tableDataVI', this.gettableval("cwbbyzx_3_7_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_13") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_13", 'tableDataVI', this.gettableval("cwbbyzx_3_7_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_14") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_14", 'tableDataVI', this.gettableval("cwbbyzx_3_7_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_15") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_15", 'tableDataVI', this.gettableval("cwbbyzx_3_7_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_16") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_16", 'tableDataVI', this.gettableval("cwbbyzx_3_7_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_17") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_17", 'tableDataVI', this.gettableval("cwbbyzx_3_7_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_18") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_18", 'tableDataVI', this.gettableval("cwbbyzx_3_7_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_19") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_19", 'tableDataVI', this.gettableval("cwbbyzx_3_7_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_20") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_20", 'tableDataVI', this.gettableval("cwbbyzx_3_7_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_7_21") {
					this.cwbbyzx_3_7_22()
					this.changetableval("cwbbyzx_3_6_21", 'tableDataVI', this.gettableval("cwbbyzx_3_7_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_1") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_1", 'tableDataVI', this.gettableval("cwbbyzx_3_7_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_2") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_2", 'tableDataVI', this.gettableval("cwbbyzx_3_7_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_3") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_3", 'tableDataVI', this.gettableval("cwbbyzx_3_7_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_4") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_4", 'tableDataVI', this.gettableval("cwbbyzx_3_7_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_5") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_5", 'tableDataVI', this.gettableval("cwbbyzx_3_7_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_6") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_6", 'tableDataVI', this.gettableval("cwbbyzx_3_7_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_7") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_7", 'tableDataVI', this.gettableval("cwbbyzx_3_7_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_8") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_8", 'tableDataVI', this.gettableval("cwbbyzx_3_7_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_9") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_9", 'tableDataVI', this.gettableval("cwbbyzx_3_7_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_10") {
					this.cwbbyzx_3_8_11()
					this.changetableval("cwbbyzx_3_6_10", 'tableDataVI', this.gettableval("cwbbyzx_3_7_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_12") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_12", 'tableDataVI', this.gettableval("cwbbyzx_3_7_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_13") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_13", 'tableDataVI', this.gettableval("cwbbyzx_3_7_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_14") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_14", 'tableDataVI', this.gettableval("cwbbyzx_3_7_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_15") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_15", 'tableDataVI', this.gettableval("cwbbyzx_3_7_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_15") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_15", 'tableDataVI', this.gettableval("cwbbyzx_3_7_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_16") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_16", 'tableDataVI', this.gettableval("cwbbyzx_3_7_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_17") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_17", 'tableDataVI', this.gettableval("cwbbyzx_3_7_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_18") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_18", 'tableDataVI', this.gettableval("cwbbyzx_3_7_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_19") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_19", 'tableDataVI', this.gettableval("cwbbyzx_3_7_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_20") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_20", 'tableDataVI', this.gettableval("cwbbyzx_3_7_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_8_21") {
					this.cwbbyzx_3_8_22()
					this.changetableval("cwbbyzx_3_6_21", 'tableDataVI', this.gettableval("cwbbyzx_3_7_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_1") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_1", 'tableDataVI', this.gettableval("cwbbyzx_3_9_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_2") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_2", 'tableDataVI', this.gettableval("cwbbyzx_3_9_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_2") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_2", 'tableDataVI', this.gettableval("cwbbyzx_3_9_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_3") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_3", 'tableDataVI', this.gettableval("cwbbyzx_3_9_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_4") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_4", 'tableDataVI', this.gettableval("cwbbyzx_3_9_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_5") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_5", 'tableDataVI', this.gettableval("cwbbyzx_3_9_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_6") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_6", 'tableDataVI', this.gettableval("cwbbyzx_3_9_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_7") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_7", 'tableDataVI', this.gettableval("cwbbyzx_3_9_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_8") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_8", 'tableDataVI', this.gettableval("cwbbyzx_3_9_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_9") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_9", 'tableDataVI', this.gettableval("cwbbyzx_3_9_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_10") {
					this.cwbbyzx_3_9_11()
					this.changetableval("cwbbyzx_3_8_10", 'tableDataVI', this.gettableval("cwbbyzx_3_9_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_12") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_12", 'tableDataVI', this.gettableval("cwbbyzx_3_9_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_13") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_13", 'tableDataVI', this.gettableval("cwbbyzx_3_9_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_14") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_14", 'tableDataVI', this.gettableval("cwbbyzx_3_9_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_15") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_15", 'tableDataVI', this.gettableval("cwbbyzx_3_9_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_16") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_16", 'tableDataVI', this.gettableval("cwbbyzx_3_9_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_17") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_17", 'tableDataVI', this.gettableval("cwbbyzx_3_9_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_18") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_18", 'tableDataVI', this.gettableval("cwbbyzx_3_9_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_19") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_19", 'tableDataVI', this.gettableval("cwbbyzx_3_9_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_20") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_20", 'tableDataVI', this.gettableval("cwbbyzx_3_9_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_9_21") {
					this.cwbbyzx_3_9_22()
					this.changetableval("cwbbyzx_3_8_21", 'tableDataVI', this.gettableval("cwbbyzx_3_9_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_1") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_1", 'tableDataVI', this.gettableval("cwbbyzx_3_9_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_2") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_2", 'tableDataVI', this.gettableval("cwbbyzx_3_9_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_3") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_3", 'tableDataVI', this.gettableval("cwbbyzx_3_9_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_4") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_4", 'tableDataVI', this.gettableval("cwbbyzx_3_9_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_5") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_5", 'tableDataVI', this.gettableval("cwbbyzx_3_9_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_6") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_6", 'tableDataVI', this.gettableval("cwbbyzx_3_9_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_7") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_7", 'tableDataVI', this.gettableval("cwbbyzx_3_9_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_8") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_8", 'tableDataVI', this.gettableval("cwbbyzx_3_9_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_9") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_9", 'tableDataVI', this.gettableval("cwbbyzx_3_9_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_10") {
					this.cwbbyzx_3_10_11()
					this.changetableval("cwbbyzx_3_8_10", 'tableDataVI', this.gettableval("cwbbyzx_3_9_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_12") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_12", 'tableDataVI', this.gettableval("cwbbyzx_3_9_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_13") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_13", 'tableDataVI', this.gettableval("cwbbyzx_3_9_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_14") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_14", 'tableDataVI', this.gettableval("cwbbyzx_3_9_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_15") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_15", 'tableDataVI', this.gettableval("cwbbyzx_3_9_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_16") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_16", 'tableDataVI', this.gettableval("cwbbyzx_3_9_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_17") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_17", 'tableDataVI', this.gettableval("cwbbyzx_3_9_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_18") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_18", 'tableDataVI', this.gettableval("cwbbyzx_3_9_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_19") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_19", 'tableDataVI', this.gettableval("cwbbyzx_3_9_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_20") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_20", 'tableDataVI', this.gettableval("cwbbyzx_3_9_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_10_21") {
					this.cwbbyzx_3_10_22()
					this.changetableval("cwbbyzx_3_8_21", 'tableDataVI', this.gettableval("cwbbyzx_3_9_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_1") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_1", 'tableDataVI', this.gettableval("cwbbyzx_3_9_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_2") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_2", 'tableDataVI', this.gettableval("cwbbyzx_3_9_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_3") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_3", 'tableDataVI', this.gettableval("cwbbyzx_3_9_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_4") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_4", 'tableDataVI', this.gettableval("cwbbyzx_3_9_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_5") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_5", 'tableDataVI', this.gettableval("cwbbyzx_3_9_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_6") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_6", 'tableDataVI', this.gettableval("cwbbyzx_3_9_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_7") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_7", 'tableDataVI', this.gettableval("cwbbyzx_3_9_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_8") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_8", 'tableDataVI', this.gettableval("cwbbyzx_3_9_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_9") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_9", 'tableDataVI', this.gettableval("cwbbyzx_3_9_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_10") {
					this.cwbbyzx_3_11_11()
					this.changetableval("cwbbyzx_3_8_10", 'tableDataVI', this.gettableval("cwbbyzx_3_9_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_12") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_12", 'tableDataVI', this.gettableval("cwbbyzx_3_9_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_13") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_13", 'tableDataVI', this.gettableval("cwbbyzx_3_9_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_14") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_14", 'tableDataVI', this.gettableval("cwbbyzx_3_9_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_15") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_15", 'tableDataVI', this.gettableval("cwbbyzx_3_9_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_16") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_16", 'tableDataVI', this.gettableval("cwbbyzx_3_9_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_17") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_17", 'tableDataVI', this.gettableval("cwbbyzx_3_9_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_18") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_18", 'tableDataVI', this.gettableval("cwbbyzx_3_9_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_19") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_19", 'tableDataVI', this.gettableval("cwbbyzx_3_9_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_20") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_20", 'tableDataVI', this.gettableval("cwbbyzx_3_9_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_11_21") {
					this.cwbbyzx_3_11_22()
					this.changetableval("cwbbyzx_3_8_21", 'tableDataVI', this.gettableval("cwbbyzx_3_9_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_1") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_1", 'tableDataVI', this.gettableval("cwbbyzx_3_9_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_2") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_2", 'tableDataVI', this.gettableval("cwbbyzx_3_9_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_3") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_3", 'tableDataVI', this.gettableval("cwbbyzx_3_9_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_4") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_4", 'tableDataVI', this.gettableval("cwbbyzx_3_9_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_5") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_5", 'tableDataVI', this.gettableval("cwbbyzx_3_9_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_6") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_6", 'tableDataVI', this.gettableval("cwbbyzx_3_9_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_7") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_7", 'tableDataVI', this.gettableval("cwbbyzx_3_9_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_8") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_8", 'tableDataVI', this.gettableval("cwbbyzx_3_9_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_9") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_9", 'tableDataVI', this.gettableval("cwbbyzx_3_9_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_10") {
					this.cwbbyzx_3_12_11()
					this.changetableval("cwbbyzx_3_8_10", 'tableDataVI', this.gettableval("cwbbyzx_3_9_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_12") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_12", 'tableDataVI', this.gettableval("cwbbyzx_3_9_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_13") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_13", 'tableDataVI', this.gettableval("cwbbyzx_3_9_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_14") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_14", 'tableDataVI', this.gettableval("cwbbyzx_3_9_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_15") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_15", 'tableDataVI', this.gettableval("cwbbyzx_3_9_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_16") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_16", 'tableDataVI', this.gettableval("cwbbyzx_3_9_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_17") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_17", 'tableDataVI', this.gettableval("cwbbyzx_3_9_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_18") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_18", 'tableDataVI', this.gettableval("cwbbyzx_3_9_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_19") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_19", 'tableDataVI', this.gettableval("cwbbyzx_3_9_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_20") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_20", 'tableDataVI', this.gettableval("cwbbyzx_3_9_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_12_21") {
					this.cwbbyzx_3_12_22()
					this.changetableval("cwbbyzx_3_8_21", 'tableDataVI', this.gettableval("cwbbyzx_3_9_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_10_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_12_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_1") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_1", 'tableDataVI', this.gettableval("cwbbyzx_3_7_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_2") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_2", 'tableDataVI', this.gettableval("cwbbyzx_3_7_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_3") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_3", 'tableDataVI', this.gettableval("cwbbyzx_3_7_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_4") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_4", 'tableDataVI', this.gettableval("cwbbyzx_3_7_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_5") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_5", 'tableDataVI', this.gettableval("cwbbyzx_3_7_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_6") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_6", 'tableDataVI', this.gettableval("cwbbyzx_3_7_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_7") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_7", 'tableDataVI', this.gettableval("cwbbyzx_3_7_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_8") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_8", 'tableDataVI', this.gettableval("cwbbyzx_3_7_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_9") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_9", 'tableDataVI', this.gettableval("cwbbyzx_3_7_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_10") {
					this.cwbbyzx_3_13_11()
					this.changetableval("cwbbyzx_3_6_10", 'tableDataVI', this.gettableval("cwbbyzx_3_7_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_12") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_12", 'tableDataVI', this.gettableval("cwbbyzx_3_7_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_13") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_13", 'tableDataVI', this.gettableval("cwbbyzx_3_7_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_14") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_14", 'tableDataVI', this.gettableval("cwbbyzx_3_7_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_15") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_15", 'tableDataVI', this.gettableval("cwbbyzx_3_7_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_15") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_15", 'tableDataVI', this.gettableval("cwbbyzx_3_7_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_16") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_16", 'tableDataVI', this.gettableval("cwbbyzx_3_7_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_17") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_17", 'tableDataVI', this.gettableval("cwbbyzx_3_7_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_18") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_18", 'tableDataVI', this.gettableval("cwbbyzx_3_7_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_19") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_19", 'tableDataVI', this.gettableval("cwbbyzx_3_7_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_20") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_20", 'tableDataVI', this.gettableval("cwbbyzx_3_7_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_13_21") {
					this.cwbbyzx_3_13_22()
					this.changetableval("cwbbyzx_3_6_21", 'tableDataVI', this.gettableval("cwbbyzx_3_7_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_1") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_1", 'tableDataVI', this.gettableval("cwbbyzx_3_14_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_2") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_2", 'tableDataVI', this.gettableval("cwbbyzx_3_14_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_3") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_3", 'tableDataVI', this.gettableval("cwbbyzx_3_14_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_4") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_4", 'tableDataVI', this.gettableval("cwbbyzx_3_14_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_5") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_5", 'tableDataVI', this.gettableval("cwbbyzx_3_14_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_6") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_6", 'tableDataVI', this.gettableval("cwbbyzx_3_14_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_7") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_7", 'tableDataVI', this.gettableval("cwbbyzx_3_14_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_8") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_8", 'tableDataVI', this.gettableval("cwbbyzx_3_14_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_9") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_9", 'tableDataVI', this.gettableval("cwbbyzx_3_14_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_10") {
					this.cwbbyzx_3_14_11()
					this.changetableval("cwbbyzx_3_13_10", 'tableDataVI', this.gettableval("cwbbyzx_3_14_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_12") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_12", 'tableDataVI', this.gettableval("cwbbyzx_3_14_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_13") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_13", 'tableDataVI', this.gettableval("cwbbyzx_3_14_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_14") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_14", 'tableDataVI', this.gettableval("cwbbyzx_3_14_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_15") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_15", 'tableDataVI', this.gettableval("cwbbyzx_3_14_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_16") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_16", 'tableDataVI', this.gettableval("cwbbyzx_3_14_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_17") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_17", 'tableDataVI', this.gettableval("cwbbyzx_3_14_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_18") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_18", 'tableDataVI', this.gettableval("cwbbyzx_3_14_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_19") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_19", 'tableDataVI', this.gettableval("cwbbyzx_3_14_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_20") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_20", 'tableDataVI', this.gettableval("cwbbyzx_3_14_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_14_21") {
					this.cwbbyzx_3_14_22()
					this.changetableval("cwbbyzx_3_13_21", 'tableDataVI', this.gettableval("cwbbyzx_3_14_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_1") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_1", 'tableDataVI', this.gettableval("cwbbyzx_3_14_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_2") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_2", 'tableDataVI', this.gettableval("cwbbyzx_3_14_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_3") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_3", 'tableDataVI', this.gettableval("cwbbyzx_3_14_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_4") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_4", 'tableDataVI', this.gettableval("cwbbyzx_3_14_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_5") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_5", 'tableDataVI', this.gettableval("cwbbyzx_3_14_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_6") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_6", 'tableDataVI', this.gettableval("cwbbyzx_3_14_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_7") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_7", 'tableDataVI', this.gettableval("cwbbyzx_3_14_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_8") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_8", 'tableDataVI', this.gettableval("cwbbyzx_3_14_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_9") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_9", 'tableDataVI', this.gettableval("cwbbyzx_3_14_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_10") {
					this.cwbbyzx_3_15_11()
					this.changetableval("cwbbyzx_3_13_10", 'tableDataVI', this.gettableval("cwbbyzx_3_14_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_12") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_12", 'tableDataVI', this.gettableval("cwbbyzx_3_14_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_13") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_13", 'tableDataVI', this.gettableval("cwbbyzx_3_14_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_14") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_14", 'tableDataVI', this.gettableval("cwbbyzx_3_14_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_15") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_15", 'tableDataVI', this.gettableval("cwbbyzx_3_14_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_16") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_16", 'tableDataVI', this.gettableval("cwbbyzx_3_14_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_17") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_17", 'tableDataVI', this.gettableval("cwbbyzx_3_14_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_18") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_18", 'tableDataVI', this.gettableval("cwbbyzx_3_14_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_19") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_19", 'tableDataVI', this.gettableval("cwbbyzx_3_14_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_20") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_20", 'tableDataVI', this.gettableval("cwbbyzx_3_14_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_15_21") {
					this.cwbbyzx_3_15_22()
					this.changetableval("cwbbyzx_3_13_21", 'tableDataVI', this.gettableval("cwbbyzx_3_14_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_1") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_1", 'tableDataVI', this.gettableval("cwbbyzx_3_14_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_2") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_2", 'tableDataVI', this.gettableval("cwbbyzx_3_14_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_3") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_3", 'tableDataVI', this.gettableval("cwbbyzx_3_14_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_4") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_4", 'tableDataVI', this.gettableval("cwbbyzx_3_14_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_5") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_5", 'tableDataVI', this.gettableval("cwbbyzx_3_14_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_6") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_6", 'tableDataVI', this.gettableval("cwbbyzx_3_14_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_7") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_7", 'tableDataVI', this.gettableval("cwbbyzx_3_14_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_8") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_8", 'tableDataVI', this.gettableval("cwbbyzx_3_14_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_9") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_9", 'tableDataVI', this.gettableval("cwbbyzx_3_14_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_10") {
					this.cwbbyzx_3_16_11()
					this.changetableval("cwbbyzx_3_13_10", 'tableDataVI', this.gettableval("cwbbyzx_3_14_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_12") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_12", 'tableDataVI', this.gettableval("cwbbyzx_3_14_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_13") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_13", 'tableDataVI', this.gettableval("cwbbyzx_3_14_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_14") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_14", 'tableDataVI', this.gettableval("cwbbyzx_3_14_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_15") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_15", 'tableDataVI', this.gettableval("cwbbyzx_3_14_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_16") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_16", 'tableDataVI', this.gettableval("cwbbyzx_3_14_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_17") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_17", 'tableDataVI', this.gettableval("cwbbyzx_3_14_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_18") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_18", 'tableDataVI', this.gettableval("cwbbyzx_3_14_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_19") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_19", 'tableDataVI', this.gettableval("cwbbyzx_3_14_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_20") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_20", 'tableDataVI', this.gettableval("cwbbyzx_3_14_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_16_21") {
					this.cwbbyzx_3_16_22()
					this.changetableval("cwbbyzx_3_13_21", 'tableDataVI', this.gettableval("cwbbyzx_3_14_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_15_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_1") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_1", 'tableDataVI', this.gettableval("cwbbyzx_3_7_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_2") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_2", 'tableDataVI', this.gettableval("cwbbyzx_3_7_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_3") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_3", 'tableDataVI', this.gettableval("cwbbyzx_3_7_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_4") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_4", 'tableDataVI', this.gettableval("cwbbyzx_3_7_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_5") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_5", 'tableDataVI', this.gettableval("cwbbyzx_3_7_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_6") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_6", 'tableDataVI', this.gettableval("cwbbyzx_3_7_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_7") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_7", 'tableDataVI', this.gettableval("cwbbyzx_3_7_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_8") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_8", 'tableDataVI', this.gettableval("cwbbyzx_3_7_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_9") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_9", 'tableDataVI', this.gettableval("cwbbyzx_3_7_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_10") {
					this.cwbbyzx_3_17_11()
					this.changetableval("cwbbyzx_3_6_10", 'tableDataVI', this.gettableval("cwbbyzx_3_7_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_12") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_12", 'tableDataVI', this.gettableval("cwbbyzx_3_7_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_13") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_13", 'tableDataVI', this.gettableval("cwbbyzx_3_7_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_14") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_14", 'tableDataVI', this.gettableval("cwbbyzx_3_7_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_15") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_15", 'tableDataVI', this.gettableval("cwbbyzx_3_7_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_15") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_15", 'tableDataVI', this.gettableval("cwbbyzx_3_7_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_16") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_16", 'tableDataVI', this.gettableval("cwbbyzx_3_7_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_17") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_17", 'tableDataVI', this.gettableval("cwbbyzx_3_7_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_18") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_18", 'tableDataVI', this.gettableval("cwbbyzx_3_7_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_19") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_19", 'tableDataVI', this.gettableval("cwbbyzx_3_7_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_20") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_20", 'tableDataVI', this.gettableval("cwbbyzx_3_7_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_17_21") {
					this.cwbbyzx_3_17_22()
					this.changetableval("cwbbyzx_3_6_21", 'tableDataVI', this.gettableval("cwbbyzx_3_7_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_8_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_17_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_1") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_1", 'tableDataVI', this.gettableval("cwbbyzx_3_18_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_2") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_2", 'tableDataVI', this.gettableval("cwbbyzx_3_18_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_3") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_3", 'tableDataVI', this.gettableval("cwbbyzx_3_18_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_4") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_4", 'tableDataVI', this.gettableval("cwbbyzx_3_18_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_5") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_5", 'tableDataVI', this.gettableval("cwbbyzx_3_18_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_6") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_6", 'tableDataVI', this.gettableval("cwbbyzx_3_18_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_7") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_7", 'tableDataVI', this.gettableval("cwbbyzx_3_18_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_8") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_8", 'tableDataVI', this.gettableval("cwbbyzx_3_18_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_9") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_9", 'tableDataVI', this.gettableval("cwbbyzx_3_18_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_10") {
					this.cwbbyzx_3_18_11()
					this.changetableval("cwbbyzx_3_17_10", 'tableDataVI', this.gettableval("cwbbyzx_3_18_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_12") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_12", 'tableDataVI', this.gettableval("cwbbyzx_3_18_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_13") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_13", 'tableDataVI', this.gettableval("cwbbyzx_3_18_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_14") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_14", 'tableDataVI', this.gettableval("cwbbyzx_3_18_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_15") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_15", 'tableDataVI', this.gettableval("cwbbyzx_3_18_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_16") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_16", 'tableDataVI', this.gettableval("cwbbyzx_3_18_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_17") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_17", 'tableDataVI', this.gettableval("cwbbyzx_3_18_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_18") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_18", 'tableDataVI', this.gettableval("cwbbyzx_3_18_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_19") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_19", 'tableDataVI', this.gettableval("cwbbyzx_3_18_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_20") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_20", 'tableDataVI', this.gettableval("cwbbyzx_3_18_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_18_21") {
					this.cwbbyzx_3_18_22()
					this.changetableval("cwbbyzx_3_17_21", 'tableDataVI', this.gettableval("cwbbyzx_3_18_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_1") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_1", 'tableDataVI', this.gettableval("cwbbyzx_3_18_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_2") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_2", 'tableDataVI', this.gettableval("cwbbyzx_3_18_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_3") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_3", 'tableDataVI', this.gettableval("cwbbyzx_3_18_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_4") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_4", 'tableDataVI', this.gettableval("cwbbyzx_3_18_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_5") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_5", 'tableDataVI', this.gettableval("cwbbyzx_3_18_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_6") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_6", 'tableDataVI', this.gettableval("cwbbyzx_3_18_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_7") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_7", 'tableDataVI', this.gettableval("cwbbyzx_3_18_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_8") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_8", 'tableDataVI', this.gettableval("cwbbyzx_3_18_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_9") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_9", 'tableDataVI', this.gettableval("cwbbyzx_3_18_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_10") {
					this.cwbbyzx_3_19_11()
					this.changetableval("cwbbyzx_3_17_10", 'tableDataVI', this.gettableval("cwbbyzx_3_18_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_12") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_12", 'tableDataVI', this.gettableval("cwbbyzx_3_18_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_13") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_13", 'tableDataVI', this.gettableval("cwbbyzx_3_18_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_14") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_14", 'tableDataVI', this.gettableval("cwbbyzx_3_18_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_15") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_15", 'tableDataVI', this.gettableval("cwbbyzx_3_18_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_16") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_16", 'tableDataVI', this.gettableval("cwbbyzx_3_18_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_17") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_17", 'tableDataVI', this.gettableval("cwbbyzx_3_18_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_18") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_18", 'tableDataVI', this.gettableval("cwbbyzx_3_18_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_19") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_19", 'tableDataVI', this.gettableval("cwbbyzx_3_18_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_20") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_20", 'tableDataVI', this.gettableval("cwbbyzx_3_18_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_19_21") {
					this.cwbbyzx_3_19_22()
					this.changetableval("cwbbyzx_3_17_21", 'tableDataVI', this.gettableval("cwbbyzx_3_18_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_1") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_1", 'tableDataVI', this.gettableval("cwbbyzx_3_18_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_2") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_2", 'tableDataVI', this.gettableval("cwbbyzx_3_18_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_3") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_3", 'tableDataVI', this.gettableval("cwbbyzx_3_18_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_4") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_4", 'tableDataVI', this.gettableval("cwbbyzx_3_18_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_5") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_5", 'tableDataVI', this.gettableval("cwbbyzx_3_18_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_6") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_6", 'tableDataVI', this.gettableval("cwbbyzx_3_18_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_7") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_7", 'tableDataVI', this.gettableval("cwbbyzx_3_18_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_8") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_8", 'tableDataVI', this.gettableval("cwbbyzx_3_18_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_9") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_9", 'tableDataVI', this.gettableval("cwbbyzx_3_18_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_10") {
					this.cwbbyzx_3_20_11()
					this.changetableval("cwbbyzx_3_17_10", 'tableDataVI', this.gettableval("cwbbyzx_3_18_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_12") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_12", 'tableDataVI', this.gettableval("cwbbyzx_3_18_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_13") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_13", 'tableDataVI', this.gettableval("cwbbyzx_3_18_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_14") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_14", 'tableDataVI', this.gettableval("cwbbyzx_3_18_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_15") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_15", 'tableDataVI', this.gettableval("cwbbyzx_3_18_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_16") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_16", 'tableDataVI', this.gettableval("cwbbyzx_3_18_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_17") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_17", 'tableDataVI', this.gettableval("cwbbyzx_3_18_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_18") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_18", 'tableDataVI', this.gettableval("cwbbyzx_3_18_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_19") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_19", 'tableDataVI', this.gettableval("cwbbyzx_3_18_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_20") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_20", 'tableDataVI', this.gettableval("cwbbyzx_3_18_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_20_21") {
					this.cwbbyzx_3_20_22()
					this.changetableval("cwbbyzx_3_17_21", 'tableDataVI', this.gettableval("cwbbyzx_3_18_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_1") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_1", 'tableDataVI', this.gettableval("cwbbyzx_3_18_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_2") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_2", 'tableDataVI', this.gettableval("cwbbyzx_3_18_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_3") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_3", 'tableDataVI', this.gettableval("cwbbyzx_3_18_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_4") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_4", 'tableDataVI', this.gettableval("cwbbyzx_3_18_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_5") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_5", 'tableDataVI', this.gettableval("cwbbyzx_3_18_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_6") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_6", 'tableDataVI', this.gettableval("cwbbyzx_3_18_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_7") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_7", 'tableDataVI', this.gettableval("cwbbyzx_3_18_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_8") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_8", 'tableDataVI', this.gettableval("cwbbyzx_3_18_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_9") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_9", 'tableDataVI', this.gettableval("cwbbyzx_3_18_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_10") {
					this.cwbbyzx_3_21_11()
					this.changetableval("cwbbyzx_3_17_10", 'tableDataVI', this.gettableval("cwbbyzx_3_18_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_12") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_12", 'tableDataVI', this.gettableval("cwbbyzx_3_18_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_13") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_13", 'tableDataVI', this.gettableval("cwbbyzx_3_18_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_14") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_14", 'tableDataVI', this.gettableval("cwbbyzx_3_18_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_15") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_15", 'tableDataVI', this.gettableval("cwbbyzx_3_18_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_16") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_16", 'tableDataVI', this.gettableval("cwbbyzx_3_18_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_17") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_17", 'tableDataVI', this.gettableval("cwbbyzx_3_18_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_18") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_18", 'tableDataVI', this.gettableval("cwbbyzx_3_18_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_19") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_19", 'tableDataVI', this.gettableval("cwbbyzx_3_18_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_20") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_20", 'tableDataVI', this.gettableval("cwbbyzx_3_18_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_21_21") {
					this.cwbbyzx_3_21_22()
					this.changetableval("cwbbyzx_3_17_21", 'tableDataVI', this.gettableval("cwbbyzx_3_18_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_1") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_1", 'tableDataVI', this.gettableval("cwbbyzx_3_18_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_2") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_2", 'tableDataVI', this.gettableval("cwbbyzx_3_18_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_3") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_3", 'tableDataVI', this.gettableval("cwbbyzx_3_18_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_4") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_4", 'tableDataVI', this.gettableval("cwbbyzx_3_18_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_5") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_5", 'tableDataVI', this.gettableval("cwbbyzx_3_18_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_6") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_6", 'tableDataVI', this.gettableval("cwbbyzx_3_18_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_7") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_7", 'tableDataVI', this.gettableval("cwbbyzx_3_18_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_8") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_8", 'tableDataVI', this.gettableval("cwbbyzx_3_18_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_9") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_9", 'tableDataVI', this.gettableval("cwbbyzx_3_18_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_10") {
					this.cwbbyzx_3_22_11()
					this.changetableval("cwbbyzx_3_17_10", 'tableDataVI', this.gettableval("cwbbyzx_3_18_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_12") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_12", 'tableDataVI', this.gettableval("cwbbyzx_3_18_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_13") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_13", 'tableDataVI', this.gettableval("cwbbyzx_3_18_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_14") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_14", 'tableDataVI', this.gettableval("cwbbyzx_3_18_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_15") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_15", 'tableDataVI', this.gettableval("cwbbyzx_3_18_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_16") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_16", 'tableDataVI', this.gettableval("cwbbyzx_3_18_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_17") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_17", 'tableDataVI', this.gettableval("cwbbyzx_3_18_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_18") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_18", 'tableDataVI', this.gettableval("cwbbyzx_3_18_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_19") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_19", 'tableDataVI', this.gettableval("cwbbyzx_3_18_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_20") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_20", 'tableDataVI', this.gettableval("cwbbyzx_3_18_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_22_21") {
					this.cwbbyzx_3_22_22()
					this.changetableval("cwbbyzx_3_17_21", 'tableDataVI', this.gettableval("cwbbyzx_3_18_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_1") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_1", 'tableDataVI', this.gettableval("cwbbyzx_3_18_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_1", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_1", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_1", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_2") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_2", 'tableDataVI', this.gettableval("cwbbyzx_3_18_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_2", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_2", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_3") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_3", 'tableDataVI', this.gettableval("cwbbyzx_3_18_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_3", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_3", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_3", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_4") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_4", 'tableDataVI', this.gettableval("cwbbyzx_3_18_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_4", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_4", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_5") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_5", 'tableDataVI', this.gettableval("cwbbyzx_3_18_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_5", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_5", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_5", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_6") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_6", 'tableDataVI', this.gettableval("cwbbyzx_3_18_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_6", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_6", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_7") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_7", 'tableDataVI', this.gettableval("cwbbyzx_3_18_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_7", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_7", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_7", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_8") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_8", 'tableDataVI', this.gettableval("cwbbyzx_3_18_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_8", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_8", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_9") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_9", 'tableDataVI', this.gettableval("cwbbyzx_3_18_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_9", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_9", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_9", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_10") {
					this.cwbbyzx_3_23_11()
					this.changetableval("cwbbyzx_3_17_10", 'tableDataVI', this.gettableval("cwbbyzx_3_18_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_10", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_10", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_10", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_12") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_12", 'tableDataVI', this.gettableval("cwbbyzx_3_18_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_12", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_12", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_12", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_13") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_13", 'tableDataVI', this.gettableval("cwbbyzx_3_18_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_13", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_13", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_14") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_14", 'tableDataVI', this.gettableval("cwbbyzx_3_18_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_14", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_14", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_14", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_15") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_15", 'tableDataVI', this.gettableval("cwbbyzx_3_18_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_15", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_15", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_16") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_16", 'tableDataVI', this.gettableval("cwbbyzx_3_18_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_16", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_16", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_16", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_17") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_17", 'tableDataVI', this.gettableval("cwbbyzx_3_18_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_17", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_17", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_18") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_18", 'tableDataVI', this.gettableval("cwbbyzx_3_18_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_18", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_18", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_18", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_19") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_19", 'tableDataVI', this.gettableval("cwbbyzx_3_18_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_19", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_19", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_20") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_20", 'tableDataVI', this.gettableval("cwbbyzx_3_18_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_20", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_20", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_20", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_23_21") {
					this.cwbbyzx_3_23_22()
					this.changetableval("cwbbyzx_3_17_21", 'tableDataVI', this.gettableval("cwbbyzx_3_18_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_19_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_21_21", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_21", 'tableDataVI') +
						this.gettableval("cwbbyzx_3_23_21", 'tableDataVI'))
				}
				if (e.cellCode == "cwbbyzx_3_24_1") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_2") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_3") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_4") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_5") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_6") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_7") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_8") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_9") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_10") {
					this.cwbbyzx_3_24_11()
				}
				if (e.cellCode == "cwbbyzx_3_24_12") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_13") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_14") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_15") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_16") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_17") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_18") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_19") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_20") {
					this.cwbbyzx_3_24_22()
				}
				if (e.cellCode == "cwbbyzx_3_24_21") {
					this.cwbbyzx_3_24_22()
				}
			},


			cwbbyzx_0_14_1() {
				this.changetableval("cwbbyzx_0_14_1", 'tableDataI', this.gettableval("cwbbyzx_0_1_1", 'tableDataI') +
					this.gettableval("cwbbyzx_0_2_1", 'tableDataI') + this.gettableval("cwbbyzx_0_3_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_4_1", 'tableDataI') + this.gettableval("cwbbyzx_0_5_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_6_1", 'tableDataI') + this.gettableval("cwbbyzx_0_7_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_8_1", 'tableDataI') + this.gettableval("cwbbyzx_0_9_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_10_1", 'tableDataI') + this.gettableval("cwbbyzx_0_11_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_12_1", 'tableDataI') + this.gettableval("cwbbyzx_0_13_1",
						'tableDataI'))
			},
			cwbbyzx_0_14_2() {
				this.changetableval("cwbbyzx_0_14_2", 'tableDataI', this.gettableval("cwbbyzx_0_1_2", 'tableDataI') +
					this.gettableval("cwbbyzx_0_2_2", 'tableDataI') + this.gettableval("cwbbyzx_0_3_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_4_2", 'tableDataI') + this.gettableval("cwbbyzx_0_5_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_6_2", 'tableDataI') + this.gettableval("cwbbyzx_0_7_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_8_2", 'tableDataI') + this.gettableval("cwbbyzx_0_9_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_10_2", 'tableDataI') + this.gettableval("cwbbyzx_0_11_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_12_2", 'tableDataI') + this.gettableval("cwbbyzx_0_13_2",
						'tableDataI'))
			},
			cwbbyzx_0_33_1() {
				this.changetableval("cwbbyzx_0_33_1", 'tableDataI', this.gettableval("cwbbyzx_0_15_1", 'tableDataI') +
					this.gettableval("cwbbyzx_0_16_1", 'tableDataI') + this.gettableval("cwbbyzx_0_17_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_18_1", 'tableDataI') + this.gettableval("cwbbyzx_0_19_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_20_1", 'tableDataI') + this.gettableval("cwbbyzx_0_21_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_22_1", 'tableDataI') + this.gettableval("cwbbyzx_0_23_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_24_1", 'tableDataI') + this.gettableval("cwbbyzx_0_25_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_26_1", 'tableDataI') + this.gettableval("cwbbyzx_0_27_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_28_1", 'tableDataI') + this.gettableval("cwbbyzx_0_29_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_30_1", 'tableDataI') + this.gettableval("cwbbyzx_0_31_1",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_32_1", 'tableDataI'))
			},
			cwbbyzx_0_33_2() {
				this.changetableval("cwbbyzx_0_33_2", 'tableDataI', this.gettableval("cwbbyzx_0_15_2", 'tableDataI') +
					this.gettableval("cwbbyzx_0_16_2", 'tableDataI') + this.gettableval("cwbbyzx_0_17_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_18_2", 'tableDataI') + this.gettableval("cwbbyzx_0_19_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_20_2", 'tableDataI') + this.gettableval("cwbbyzx_0_21_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_22_2", 'tableDataI') + this.gettableval("cwbbyzx_0_23_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_24_2", 'tableDataI') + this.gettableval("cwbbyzx_0_25_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_26_2", 'tableDataI') + this.gettableval("cwbbyzx_0_27_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_28_2", 'tableDataI') + this.gettableval("cwbbyzx_0_29_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_30_2", 'tableDataI') + this.gettableval("cwbbyzx_0_31_2",
						'tableDataI') +
					this.gettableval("cwbbyzx_0_32_2", 'tableDataI'))
			},
			cwbbyzx_0_48_1() {
				this.changetableval("cwbbyzx_0_48_1", 'tableDataci', this.gettableval("cwbbyzx_0_35_1", 'tableDataci') +
					this.gettableval("cwbbyzx_0_36_1", 'tableDataci') + this.gettableval("cwbbyzx_0_37_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_38_1", 'tableDataci') + this.gettableval("cwbbyzx_0_39_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_40_1", 'tableDataci') + this.gettableval("cwbbyzx_0_41_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_42_1", 'tableDataci') + this.gettableval("cwbbyzx_0_43_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_44_1", 'tableDataci') + this.gettableval("cwbbyzx_0_45_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_46_1", 'tableDataci') + this.gettableval("cwbbyzx_0_47_1",
						'tableDataci'))
			},
			cwbbyzx_0_48_2() {
				this.changetableval("cwbbyzx_0_48_2", 'tableDataci', this.gettableval("cwbbyzx_0_35_2", 'tableDataci') +
					this.gettableval("cwbbyzx_0_36_2", 'tableDataci') + this.gettableval("cwbbyzx_0_37_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_38_2", 'tableDataci') + this.gettableval("cwbbyzx_0_39_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_40_2", 'tableDataci') + this.gettableval("cwbbyzx_0_41_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_42_2", 'tableDataci') + this.gettableval("cwbbyzx_0_43_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_44_2", 'tableDataci') + this.gettableval("cwbbyzx_0_45_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_46_2", 'tableDataci') + this.gettableval("cwbbyzx_0_47_2",
						'tableDataci'))
			},
			cwbbyzx_0_59_1() {
				this.changetableval("cwbbyzx_0_59_1", 'tableDataci', this.gettableval("cwbbyzx_0_49_1", 'tableDataci') +
					this.gettableval("cwbbyzx_0_50_1", 'tableDataci') + this.gettableval("cwbbyzx_0_51_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_52_1", 'tableDataci') + this.gettableval("cwbbyzx_0_53_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_54_1", 'tableDataci') + this.gettableval("cwbbyzx_0_55_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_56_1", 'tableDataci') + this.gettableval("cwbbyzx_0_57_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_58_1", 'tableDataci'))
			},
			cwbbyzx_0_59_2() {
				this.changetableval("cwbbyzx_0_59_2", 'tableDataci', this.gettableval("cwbbyzx_0_49_2", 'tableDataci') +
					this.gettableval("cwbbyzx_0_50_2", 'tableDataci') + this.gettableval("cwbbyzx_0_51_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_52_2", 'tableDataci') + this.gettableval("cwbbyzx_0_53_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_54_2", 'tableDataci') + this.gettableval("cwbbyzx_0_55_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_56_2", 'tableDataci') + this.gettableval("cwbbyzx_0_57_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_58_2", 'tableDataci'))
			},
			cwbbyzx_0_71_1() {
				this.changetableval("cwbbyzx_0_71_1", 'tableDataci', this.gettableval("cwbbyzx_0_61_1", 'tableDataci') +
					this.gettableval("cwbbyzx_0_62_1", 'tableDataci') + this.gettableval("cwbbyzx_0_63_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_64_1", 'tableDataci') + this.gettableval("cwbbyzx_0_65_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_66_1", 'tableDataci') + this.gettableval("cwbbyzx_0_67_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_68_1", 'tableDataci') + this.gettableval("cwbbyzx_0_69_1",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_70_1", 'tableDataci'))
			},
			cwbbyzx_0_71_2() {
				this.changetableval("cwbbyzx_0_71_2", 'tableDataci', this.gettableval("cwbbyzx_0_61_2", 'tableDataci') +
					this.gettableval("cwbbyzx_0_62_2", 'tableDataci') + this.gettableval("cwbbyzx_0_63_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_64_2", 'tableDataci') + this.gettableval("cwbbyzx_0_65_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_66_2", 'tableDataci') + this.gettableval("cwbbyzx_0_67_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_68_2", 'tableDataci') + this.gettableval("cwbbyzx_0_69_2",
						'tableDataci') +
					this.gettableval("cwbbyzx_0_70_2", 'tableDataci'))
			},

			// 第二张表

			cwbbyzx_1_19_1(){
				this.changetableval("cwbbyzx_1_19_1", 'tableDataII', this.gettableval("cwbbyzx_1_1_1", 'tableDataII') -
					this.gettableval("cwbbyzx_1_2_1", 'tableDataII') - this.gettableval("cwbbyzx_1_3_1",
						'tableDataII') -
					this.gettableval("cwbbyzx_1_4_1", 'tableDataII') - this.gettableval("cwbbyzx_1_5_1",
						'tableDataII') -
					this.gettableval("cwbbyzx_1_6_1", 'tableDataII') - this.gettableval("cwbbyzx_1_7_1",
						'tableDataII') +
					this.gettableval("cwbbyzx_1_10_1", 'tableDataII') + this.gettableval("cwbbyzx_1_11_1",
						'tableDataII') +
					this.gettableval("cwbbyzx_1_14_1", 'tableDataII') + this.gettableval("cwbbyzx_1_15_1",
						'tableDataII')+
					this.gettableval("cwbbyzx_1_16_1", 'tableDataII') + this.gettableval("cwbbyzx_1_17_1",
						'tableDataII')+
					this.gettableval("cwbbyzx_1_18_1", 'tableDataII'))
			},
			cwbbyzx_1_19_2(){
				this.changetableval("cwbbyzx_1_19_2", 'tableDataII', this.gettableval("cwbbyzx_1_1_2", 'tableDataII') -
					this.gettableval("cwbbyzx_1_2_2", 'tableDataII') - this.gettableval("cwbbyzx_1_3_2",
						'tableDataII') -
					this.gettableval("cwbbyzx_1_4_2", 'tableDataII') - this.gettableval("cwbbyzx_1_5_2",
						'tableDataII') -
					this.gettableval("cwbbyzx_1_6_2", 'tableDataII') - this.gettableval("cwbbyzx_1_7_2",
						'tableDataII') +
					this.gettableval("cwbbyzx_1_10_2", 'tableDataII') + this.gettableval("cwbbyzx_1_11_2",
						'tableDataII') +
					this.gettableval("cwbbyzx_1_14_2", 'tableDataII') + this.gettableval("cwbbyzx_1_15_2",
						'tableDataII')+
					this.gettableval("cwbbyzx_1_16_2", 'tableDataII') + this.gettableval("cwbbyzx_1_17_2",
						'tableDataII')+
					this.gettableval("cwbbyzx_1_18_2", 'tableDataII'))
			},
			// 第四张表
			cwbbyzx_3_1_11(){
				this.changetableval("cwbbyzx_3_1_11", 'tableDataVI', this.gettableval("cwbbyzx_3_1_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_1_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_10", 'tableDataVI'))
			},
			cwbbyzx_3_1_22(){
				this.changetableval("cwbbyzx_3_1_22", 'tableDataVI', this.gettableval("cwbbyzx_3_1_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_1_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_1_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_1_21", 'tableDataVI'))
			},
			cwbbyzx_3_2_11(){
				this.changetableval("cwbbyzx_3_2_11", 'tableDataVI', this.gettableval("cwbbyzx_3_2_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_2_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_10", 'tableDataVI'))
			},
			cwbbyzx_3_2_22(){
				this.changetableval("cwbbyzx_3_2_22", 'tableDataVI', this.gettableval("cwbbyzx_3_2_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_2_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_2_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_2_21", 'tableDataVI'))
			},
			cwbbyzx_3_3_11(){
				this.changetableval("cwbbyzx_3_3_11", 'tableDataVI', this.gettableval("cwbbyzx_3_3_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_3_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_10", 'tableDataVI'))
			},
			cwbbyzx_3_3_22(){
				this.changetableval("cwbbyzx_3_3_22", 'tableDataVI', this.gettableval("cwbbyzx_3_3_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_3_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_3_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_3_21", 'tableDataVI'))
			},
			cwbbyzx_3_4_11(){
				this.changetableval("cwbbyzx_3_4_11", 'tableDataVI', this.gettableval("cwbbyzx_3_4_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_4_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_10", 'tableDataVI'))
			},
			cwbbyzx_3_4_22(){
				this.changetableval("cwbbyzx_3_4_22", 'tableDataVI', this.gettableval("cwbbyzx_3_4_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_4_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_4_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_4_21", 'tableDataVI'))
			},
			cwbbyzx_3_5_11(){
				this.changetableval("cwbbyzx_3_5_11", 'tableDataVI', this.gettableval("cwbbyzx_3_5_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_5_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_10", 'tableDataVI'))
			},
			cwbbyzx_3_5_22(){
				this.changetableval("cwbbyzx_3_5_22", 'tableDataVI', this.gettableval("cwbbyzx_3_5_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_5_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_5_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_5_21", 'tableDataVI'))
			},
			cwbbyzx_3_6_11(){
				this.changetableval("cwbbyzx_3_6_11", 'tableDataVI', this.gettableval("cwbbyzx_3_6_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_6_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_10", 'tableDataVI'))
			},
			cwbbyzx_3_6_22(){
				this.changetableval("cwbbyzx_3_6_22", 'tableDataVI', this.gettableval("cwbbyzx_3_6_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_6_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_6_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_6_21", 'tableDataVI'))
			},
			cwbbyzx_3_7_11(){
				this.changetableval("cwbbyzx_3_7_11", 'tableDataVI', this.gettableval("cwbbyzx_3_7_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_7_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_10", 'tableDataVI'))
			},
			cwbbyzx_3_7_22(){
				this.changetableval("cwbbyzx_3_7_22", 'tableDataVI', this.gettableval("cwbbyzx_3_7_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_7_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_7_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_7_21", 'tableDataVI'))
			},
			cwbbyzx_3_8_11(){
				this.changetableval("cwbbyzx_3_8_11", 'tableDataVI', this.gettableval("cwbbyzx_3_8_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_8_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_10", 'tableDataVI'))
			},
			cwbbyzx_3_8_22(){
				this.changetableval("cwbbyzx_3_8_22", 'tableDataVI', this.gettableval("cwbbyzx_3_8_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_8_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_8_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_8_21", 'tableDataVI'))
			},
			cwbbyzx_3_9_11(){
				this.changetableval("cwbbyzx_3_9_11", 'tableDataVI', this.gettableval("cwbbyzx_3_9_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_9_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_10", 'tableDataVI'))
			},
			cwbbyzx_3_9_22(){
				this.changetableval("cwbbyzx_3_9_22", 'tableDataVI', this.gettableval("cwbbyzx_3_9_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_9_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_9_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_9_21", 'tableDataVI'))
			},
			cwbbyzx_3_10_11(){
				this.changetableval("cwbbyzx_3_10_11", 'tableDataVI', this.gettableval("cwbbyzx_3_10_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_10_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_10", 'tableDataVI'))
			},
			cwbbyzx_3_10_22(){
				this.changetableval("cwbbyzx_3_10_22", 'tableDataVI', this.gettableval("cwbbyzx_3_10_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_10_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_10_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_10_21", 'tableDataVI'))
			},
			cwbbyzx_3_11_11(){
				this.changetableval("cwbbyzx_3_11_11", 'tableDataVI', this.gettableval("cwbbyzx_3_11_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_11_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_10", 'tableDataVI'))
			},
			cwbbyzx_3_11_22(){
				this.changetableval("cwbbyzx_3_11_22", 'tableDataVI', this.gettableval("cwbbyzx_3_11_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_11_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_11_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_11_21", 'tableDataVI'))
			},
			cwbbyzx_3_12_11(){
				this.changetableval("cwbbyzx_3_12_11", 'tableDataVI', this.gettableval("cwbbyzx_3_12_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_12_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_10", 'tableDataVI'))
			},
			cwbbyzx_3_12_22(){
				this.changetableval("cwbbyzx_3_12_22", 'tableDataVI', this.gettableval("cwbbyzx_3_12_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_12_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_12_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_12_21", 'tableDataVI'))
			},
			cwbbyzx_3_13_11(){
				this.changetableval("cwbbyzx_3_13_11", 'tableDataVI', this.gettableval("cwbbyzx_3_13_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_13_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_10", 'tableDataVI'))
			},
			cwbbyzx_3_13_22(){
				this.changetableval("cwbbyzx_3_13_22", 'tableDataVI', this.gettableval("cwbbyzx_3_13_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_13_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_13_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_13_21", 'tableDataVI'))
			},
			cwbbyzx_3_14_11(){
				this.changetableval("cwbbyzx_3_14_11", 'tableDataVI', this.gettableval("cwbbyzx_3_14_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_14_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_10", 'tableDataVI'))
			},
			cwbbyzx_3_14_22(){
				this.changetableval("cwbbyzx_3_14_22", 'tableDataVI', this.gettableval("cwbbyzx_3_14_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_14_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_14_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_14_21", 'tableDataVI'))
			},
			cwbbyzx_3_15_11(){
				this.changetableval("cwbbyzx_3_15_11", 'tableDataVI', this.gettableval("cwbbyzx_3_15_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_15_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_10", 'tableDataVI'))
			},
			cwbbyzx_3_15_22(){
				this.changetableval("cwbbyzx_3_15_22", 'tableDataVI', this.gettableval("cwbbyzx_3_15_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_15_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_15_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_15_21", 'tableDataVI'))
			},
			cwbbyzx_3_16_11(){
				this.changetableval("cwbbyzx_3_16_11", 'tableDataVI', this.gettableval("cwbbyzx_3_16_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_16_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_10", 'tableDataVI'))
			},
			cwbbyzx_3_16_22(){
				this.changetableval("cwbbyzx_3_16_22", 'tableDataVI', this.gettableval("cwbbyzx_3_16_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_16_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_16_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_16_21", 'tableDataVI'))
			},
			cwbbyzx_3_17_11(){
				this.changetableval("cwbbyzx_3_17_11", 'tableDataVI', this.gettableval("cwbbyzx_3_17_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_17_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_10", 'tableDataVI'))
			},
			cwbbyzx_3_17_22(){
				this.changetableval("cwbbyzx_3_17_22", 'tableDataVI', this.gettableval("cwbbyzx_3_17_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_17_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_17_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_17_21", 'tableDataVI'))
			},
			cwbbyzx_3_18_11(){
				this.changetableval("cwbbyzx_3_18_11", 'tableDataVI', this.gettableval("cwbbyzx_3_18_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_18_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_10", 'tableDataVI'))
			},
			cwbbyzx_3_18_22(){
				this.changetableval("cwbbyzx_3_18_22", 'tableDataVI', this.gettableval("cwbbyzx_3_18_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_18_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_18_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_18_21", 'tableDataVI'))
			},
			cwbbyzx_3_19_11(){
				this.changetableval("cwbbyzx_3_19_11", 'tableDataVI', this.gettableval("cwbbyzx_3_19_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_19_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_10", 'tableDataVI'))
			},
			cwbbyzx_3_19_22(){
				this.changetableval("cwbbyzx_3_19_22", 'tableDataVI', this.gettableval("cwbbyzx_3_19_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_19_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_19_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_19_21", 'tableDataVI'))
			},
			cwbbyzx_3_20_11(){
				this.changetableval("cwbbyzx_3_20_11", 'tableDataVI', this.gettableval("cwbbyzx_3_20_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_20_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_10", 'tableDataVI'))
			},
			cwbbyzx_3_20_22(){
				this.changetableval("cwbbyzx_3_20_22", 'tableDataVI', this.gettableval("cwbbyzx_3_20_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_20_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_20_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_20_21", 'tableDataVI'))
			},
			cwbbyzx_3_21_11(){
				this.changetableval("cwbbyzx_3_21_11", 'tableDataVI', this.gettableval("cwbbyzx_3_21_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_21_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_10", 'tableDataVI'))
			},
			cwbbyzx_3_21_22(){
				this.changetableval("cwbbyzx_3_21_22", 'tableDataVI', this.gettableval("cwbbyzx_3_21_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_21_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_21_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_21_21", 'tableDataVI'))
			},
			cwbbyzx_3_22_11(){
				this.changetableval("cwbbyzx_3_22_11", 'tableDataVI', this.gettableval("cwbbyzx_3_22_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_22_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_10", 'tableDataVI'))
			},
			cwbbyzx_3_22_22(){
				this.changetableval("cwbbyzx_3_22_22", 'tableDataVI', this.gettableval("cwbbyzx_3_22_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_22_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_22_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_22_21", 'tableDataVI'))
			},
			cwbbyzx_3_23_11(){
				this.changetableval("cwbbyzx_3_23_11", 'tableDataVI', this.gettableval("cwbbyzx_3_23_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_23_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_10", 'tableDataVI'))
			},
			cwbbyzx_3_23_22(){
				this.changetableval("cwbbyzx_3_23_22", 'tableDataVI', this.gettableval("cwbbyzx_3_23_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_23_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_23_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_23_21", 'tableDataVI'))
			},
			cwbbyzx_3_24_11(){
				this.changetableval("cwbbyzx_3_24_11", 'tableDataVI', this.gettableval("cwbbyzx_3_24_1", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_2", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_3", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_4", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_5", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_24_6", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_7", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_8", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_9", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_10", 'tableDataVI'))
			},
			cwbbyzx_3_24_22(){
				this.changetableval("cwbbyzx_3_24_22", 'tableDataVI', this.gettableval("cwbbyzx_3_24_12", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_13", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_14", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_15", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_16", 'tableDataVI') -
					this.gettableval("cwbbyzx_3_24_17", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_18", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_19", 'tableDataVI')+ this.gettableval("cwbbyzx_3_24_20", 'tableDataVI') +
					this.gettableval("cwbbyzx_3_24_21", 'tableDataVI'))
			},
			gettableval(changecode, table, old) {
				var head = ''
				if (table == 'tableDataI' || table == 'tableDataci') {
					head = 'ZeroHea'
				}
				if (table == 'tableDataII') {
					head = 'IHead'
				}
				if (table == 'tableDataIII') {
					head = 'IIHead'
				}
				if (table == 'tableDataVI') {
					head = 'IIIHead'
				}
				var a
				if (this[table] && this[head]) {
					for (let i = 0; i < this[table].length; i++) {
						for (let j = 0; j < this[head].length; j++) {
							if (this[table][i][this[head][j]] && this[table][i][this[head][j]].cellCode && this[table][i][
									this[
										head][j]
								].cellVal && this[table][i][this[head][j]].cellCode == changecode) {
								if (old) {
									if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
										a = 0
									} else {
										a = parseFloat(this[table][i][this[head][j]].goujgxValue)
									}
								} else {
									if (this[table][i][this[head][j]].cellVal == '- -') {
										a = 0
									} else {
										a = parseFloat(this[table][i][this[head][j]].cellVal || 0)
									}
								}
								break
							}
						}
					}
				}

				a = a || 0
				return a
			},
			changetableval(changecode, table, newval, checkq) {
				var newval = newval || 0
				newval = this.toFixed(newval,2)
				var head = ''
				if (table == 'tableDataI' || table == 'tableDataci') {
					head = 'ZeroHea'
				}
				if (table == 'tableDataII') {
					head = 'IHead'
				}
				if (table == 'tableDataIII') {
					head = 'IIHead'
				}
				if (table == 'tableDataVI') {
					head = 'IIIHead'
				}
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (this[table][i][this[head][j]] && this[table][i][this[head][j]].cellCode && typeof this[table][
								i
							][this[head][j]].cellVal != 'undefined' && typeof this[table][i][this[head][j]].cellVal !=
							undefined && this[table][i][this[head][j]].cellCode == changecode) {
							if (this[table][i][this[head][j]].cellVal != newval) {
								if (this.suosq.substring(4, 6) < 5 && checkq) {
									this[table][i][this[head][j]].cellVal = ""
								} else {
									this[table][i][this[head][j]].cellVal = newval + ""
								}
								this.inputblur({
									cellCode: changecode,
									cellVal: newval
								})
								break
							}
						}
					}
				}
			},

		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>
